import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef, Input, Renderer2, TemplateRef } from '@angular/core';
import { PaymentService } from 'src/app/services/payment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgForm, FormControl, Validators, AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { IGetPermissionMandatoryField, IListOfValues, IEFTSettingListModel, ICountry, IState, ISaveModel, IFacilityInfo, IFacilityInfoACH } from '../interface';
import { FacilityService } from 'src/app/services/facility.service';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { Observable, Subscription } from 'rxjs';
import { TransferData } from 'src/app/facilityOperations/facOps-customer/transfer-data';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { environment } from 'src/environments/environment';
import { AppService } from 'src/app/services/app.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { CommonMethodService } from '../common-method.service';
import {
  EACHAccountType, EACHCheckResultCode, EACHPaymentGateway, ECountries, ECreditCards, EOpenEdgeResponseCode, EPaymentGateway,
  EPaymentModes, EPaymentOrigin, EPaymentTransactionType, EPaymentTransactionTypes, ETransactionTypes, EUserFunctions
} from '../enum';
import { TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { IAutoPayInfo } from '../models/CustomerModel';
import { StripeTerminalSignalRService } from 'src/app/services/payment/stripe-terminal-signal-r.service';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
import { PayFieldsSdkLoaderService } from '../payfields-sdk-loader.service';
import { FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';

declare var GlobalPayments: any;
declare var customcheckout: any;
import{interval} from 'rxjs';
@Component({
    selector: 'app-autoPay',
    templateUrl: 'autoPay.component.html',
    styleUrls: ['autoPay.component.scss'],
    standalone: false
})

export class AutoPaySharedComponent implements OnInit, OnDestroy, OnChanges {
  @Input() tenantInfo = null;
  @Input() tenantModel = null;
  datepipe: DatePipe = new DatePipe('en');
  @ViewChild('showStripePage', { static: true }) showStripePage: TemplateRef<any>;
  @ViewChild('AutoPayModalRef', { static: true }) autoPayModalRef: ModalDirective;
  @Input() stripePublishableKey = '';
  @Input() StripeUnifiedAccountId = '';
  @Input() enableAddressAutofill = false;
  @Input() isAutoPayRequired!: boolean;
  @Output() cancelAutopay : EventEmitter<boolean> = new EventEmitter<boolean>();
  stripeClientSecret = '';
  stripeSetupIntent = '';
  disableStripeAchOnfile:  boolean | null = null;
  stripeModalRef: BsModalRef;
  mandateId = '';
  selectedPaymentMode = 0;
  statusAutopay = {
    isProcessed: false,
    isFailed: false
  };
  stripeLoader = {
    isStripeterminal: false,
    isPyamnet: true
  }
  isAchCcFailed = false;
  initialCcAndAchData = null;
  initialEftData = null;
  initialData = null;
  modalDeleteAutopay: BsModalRef;
  modalRefSelectDevice: BsModalRef;
  @Output() emitAutopayData: EventEmitter<any> = new EventEmitter<any>();
  tenantAutoPayDetails: any;
  @Input() paymentOrigin = 0;
  @Input() currentLeaseNo = 0;
  @ViewChild('printReceiptPopup', { static: true }) printReceipt: ModalDirective;
  @ViewChild('printf') myIframeAutopayHistory: ElementRef;
  @ViewChild('selectStripeDevicePopup', { static: true }) public selectStripeDevicePopup: TemplateRef<any>;
  filterSettings = { mode: 'Immediate', immediatemodedelay: 5 };
  autopayHistoryForUnit = [];
  autopayInfoForUnit = null;
  autoPayHistory = [];
  selectedUnitLease = 0;
  openEdgeBillingFields = '';
  UniqueIdentifier;
  emailIdsPattern = '^([\\w�-��-��-�]+[\\w�-��-��-�!#$%?^&*+-=]*\\@[\\w�-��-��-�\-]+(?:\\.[\\w�-��-��-�]{2,}[\\w�-��-��-�]*)+)([\,\;]{1}[\\w�-��-��-�]+[\\w�-��-��-�!#$%?^&*+-=]*\\@[\\w�-��-��-�\-]+(?:\\.[\\w�-��-��-�]{2,}[\\w�-��-��-�]*)+)*$';
  public PhoneNumberMask: String = '(000)000-0000';
  countryList = [];
  stateList = [];
  IsmodelShow = false;
  tdNameOnCard = '';
  tdFName = '';
  tdLName = '';
  tdEmail = '';
  tdAddress = '';
  tdCity = '';
  tdState = null;
  tdCountry = 1;
  tdZip = '';
  tdCellphone = '';
  customerId = '';
  SeriesId ='';
  tdModalRef: BsModalRef;
  achModalRef: BsModalRef;
  linkedAutopayModalRef: BsModalRef;
  customCheckoutValid = false;
  EPaymentGateway = EPaymentGateway;
  setupTerminalAutoPayRes: any;
  @Input() isModifyRental = false;
  @Input() credentials;
  @Input() Currentstore;
  @Output() responseData: EventEmitter<any> = new EventEmitter<any>();
  @Input() paymentGateWay = 0;
  @Input() dayEndSetting;
  @Input() resetPostPayment: boolean = false;
  @Output() autopayCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('txtTransactionId', { static: false }) txtTransactionId: ElementRef;
  @ViewChild('pay-button', { static: false }) payButton: ElementRef;
  @ViewChild('AliaseIFrame', { static: true }) AliaseIFrame: ModalDirective;
  @ViewChild('Eftcustomerform', { static: true }) Eftcustomerform: NgForm;
  @ViewChild('showTDHostedForm', { static: true }) templateTDHosted: TemplateRef<any>;
  @ViewChild('showAChHostedForm', { static: false }) templateACHHosted: TemplateRef<any>;
  @ViewChild('showTDchallengeForm', { static: true }) showTDchallengeForm: TemplateRef<any>;
  @ViewChild('linkedAutopay', { static: true }) linkedAutopay: TemplateRef<any>;
  @Input() defaultCountryId = 1;
  @Input() AutopayProfileUpdate;
  @Input() facilityCreditCards;
  @Input() achSettingPaymentGateway;
  @Input() quickProspectTenantInfo;
  modalConfig = {
    backdrop: 'static',
    ignoreBackdropClick: true,
    keyboard: false
  };
  cellphoneNotValid = false;
  tdDetails = '';
  lastSelection = "";
  process: boolean = false;
  autopayFailed: boolean = false;
  checkautoPay = false;
  transitNo;
  autopaydata
  facilityInfoEFT: IEFTSettingListModel;
  IsEnableEFT: boolean = false;
  isEnableAch: boolean = false;
  Accountname;
  email: boolean;
  printAutopay: boolean
  bankcode;
  ACHRoutingNo;
  ACHaccountno;
  ACHaccounttype;
  ACHaccountclass;
  emitAliaseKey = '';
  autoCCDays = 0;
  Accountnumber
  cardNumber;
  zipCode;
  Address;
  nameOnCard;
  expMonth;
  expYear;
  loaderIcon: Promise<boolean>;
  loaderIconTD: Promise<boolean>;
  loaderIconAuto: Promise<boolean>;
  showAliasIFrame: boolean;
  urlSafeAlias: any;
  @ViewChild('CNPAliasIFrame', { static: false }) iframeAlias: ElementRef;
  @ViewChild('CNPAliasIFrameTD', { static: false }) iframeTD: ElementRef;
  componentName: string = 'autoPay.component.html';
  TDformName: string = 'tdAutopayForm'
  sessionId: any;
  OrderId: any;
  leaseNo;
  TenantId;
  public accounttype: IListOfValues[];
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  cTypeId: number = ECreditCards.Visa;
  modeSelect: any = 0;
  browserLangauge: string;
  userAgent: string;
  headers: string;
  screenHeight: number;
  screenWidth: number;
  colorDepth: number;
  time_zone: number;
  profileResponse: any;
  mandatoryFieldsTD = [];
  isTDEmailValid = true;
  disableSaveButtonForTD :boolean = false;
  fieldsRequired = false;
  disableCancelButton = false;
  sessiondata: any;
  subTdhost: any;
  cofSeriesIdRes: any;
  private paymentGetCCTStatusInterval = environment.paymentGetCCTStatusInterval;
  private paymentMaxWaitTime = environment.paymentMaxWaitTime;
  tdChallengeModalRef: BsModalRef;
  UpdateProfile: boolean = false;
  private baseUrl = this.appService.config.apiBaseUrl;
  editRightAutoCCProcessDay = false;
  viewRightAutoCCProcessDay = false;
  emptyStateList = false;
  initialCCTOrderId: any;
  initialCCTUniqueId: any;
  initialACHOrderId: any;
  autopayFailReason: any;
  initiatedVoidCC = false;
  initiatedStripEMVPayment = false;
  autoAchForm: FormGroup;
  autopayLinledUnitList = [];
  enableLinkedUnitLeaseNo = [];
  private stripeResponseSubscription: Subscription;
  facilityCode: any;
  isAutoPopulateBillingInfo = false;
  customerInfo = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    CompanyName: '',
    AddressOne: '',
    City: '',
    CountryCode: '',
    StateCode: '',
    StateId: 0,
    PostalCode: '',
    CountryId: 0,
    CellPhoneNumber: '',
    Email: '',
    FullName: ''
  }
  requestParam: String;
  customerInfoPresent = false;
  RoutingNumber: string = '';
  achFirstName: string = '';
  achLastName: string = '';
  achAddress: string = '';
  achCountry: number = 1;
  achCity: string = '';
  achState = null;
  public wrapSettings: TextWrapSettingsModel;
  CardTerminalForm = false;
  CardWebsiteForm = false;
  ACHForm = false;
  EFTForm = false;
  showTDForm = false;
  countryId: number;
  isLoaderActive: boolean = false;
  isTDEmv = {
    isTransactionWaitTime: false,
    isPortClosingWaitTime: false
  };
  isProcessAutoPayComplete = {
    SetUpIntentId: '',
    OrderId: 0,
    isProcessed: false
  };
  terminalDevicesList = [];
  selectStripeReaderId = '';
  isStripeResetTerminal = false;
  disablesavebutton: boolean = false;
  CCPlaceHolder: string;
  achPlaceHolder: string;
  eftPlaceHolder:string;
  isUnitChanged =false;

  // PayFields Card on File (OpenEdge Transactions API) — standalone enrollment from
  // Modify Rental / Rental / Transfer / MakePayment, independent of an active payment.
  showPayFieldsCardOnFileForm = false;
  isPayFieldsCardOnFileFormReady = false;
  private payFieldsCardOnFileSecureForm: any = null;
  private payFieldsCardOnFileDialogElement: HTMLElement | null = null;
  private payFieldsCardOnFileIframeObserver: MutationObserver | null = null;
  private payFieldsCardOnFileTokenizationResult: any = null;
  isPayFieldsEnrollmentPending = false;
  private payFieldsEnrollmentAttempt = 0;
  private payFieldsTokenPending = false;
  private payFieldsTokenTimer: ReturnType<typeof setTimeout>;
  private payFieldsEnrollmentTimer: ReturnType<typeof setTimeout>;
  private payFieldsFocusTimer: ReturnType<typeof setTimeout>;
  private payFieldsFocusTrap: FocusTrap | null = null;
  private payFieldsPreviousFocus: HTMLElement | null = null;
  private payFieldsPreviousCard: any = null;
  private payFieldsEnrollmentContext: { facilityId: number; leaseNo: number; selectedUnitLease: number } = null;
  private payFieldsDestroyed = false;
  private payFieldsStateRequest = 0;
  payFieldsStateRequired = false;
  payFieldsMandatoryFieldsLoaded = false;
  private payFieldsCardOnFileCardValidity = { number: false, expiration: false, cvv: false };
  payFieldsCardOnFileBillingDetails = {
    firstName: '',
    middleName: '',
    lastName: '',
    companyName: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    postalCode: '',
    countryId: environment.defaultCountryId,
    stateId: 0
  };
  @ViewChild('payFieldsCardOnFileDialog', { static: false, read: ElementRef })
  set payFieldsCardOnFileDialog(dialog: ElementRef<HTMLElement> | undefined) {
    this.payFieldsCardOnFileIframeObserver?.disconnect();
    this.payFieldsCardOnFileIframeObserver = null;
    this.payFieldsCardOnFileDialogElement = dialog?.nativeElement ?? null;
    if (dialog || this.showPayFieldsCardOnFileForm) clearTimeout(this.payFieldsFocusTimer);
    this.payFieldsFocusTrap?.destroy();
    this.payFieldsFocusTrap = null;
    if (dialog && this.showPayFieldsCardOnFileForm && !this.payFieldsDestroyed) {
      if (this.payFieldsCardOnFileSecureForm) this.watchPayFieldsCardOnFileIframes();
      const trap = this.focusTrapFactory.create(dialog.nativeElement);
      this.payFieldsFocusTrap = trap;
      this.payFieldsFocusTimer = setTimeout(() => {
        if (this.payFieldsFocusTrap === trap && !this.payFieldsDestroyed) {
          trap.focusInitialElement();
        }
      }, 0);
    }
  }

  constructor(private paymentService: PaymentService,
    public facilityService: FacilityService,
    public sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private generalService: GeneralService,
    private userSessionService: UserSessionService,
    private data: DataService,
    private facOpsDataService: FacOpsDataService,
    private transferdataservice: TransferData,
    private modalService: BsModalService,
    private renderer: Renderer2,
    public customerDataService: CustomerDataService,
    private appService: AppService,
    private prospectSerice: ProspectService,
    private commonMethod: CommonMethodService,
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private currencyPipe: CurrencyPipe,
    private signalRService: StripeTerminalSignalRService,
    private modalWrapper: ModalWrapperService,
    private payFieldsSdkLoader: PayFieldsSdkLoaderService,
    private focusTrapFactory: FocusTrapFactory) { }

  ngOnInit(): void {
    this.setUserPermissions();
    this.process = false;
    this.Eftcustomerform.form.addControl('TransitNo', new FormControl());
    this.Eftcustomerform.form.addControl('AccoutNo', new FormControl());
    this.Eftcustomerform.form.addControl('AccountName', new FormControl());
    this.Eftcustomerform.form.addControl('Bankcode', new FormControl());
    this.autoAchForm = this.formBuilder.group({
      RoutingNumber: "",
      CheckNumber: "",
      AccountNumber: "",
      NameOnAccount: "",
      ACHAccounttype: EACHAccountType.Checking
    });

    if (this.data.custimerInfoStorage) {
      if (
        this.data.custimerInfoStorage.hasOwnProperty('tenantId') === true &&
        this.data.custimerInfoStorage.hasOwnProperty('facilityID') === true &&
        this.data.custimerInfoStorage.hasOwnProperty('leaseNo') === true
      ) {
        this.TenantId = this.data.custimerInfoStorage.tenantId;
        this.leaseNo = this.data.custimerInfoStorage.leaseNo;
        this.Currentstore = this.data.custimerInfoStorage.facilityID
      }
    } else {
      this.leaseNo = this.generateLeaseNumber();
    }
    if (this.checkautoPay) {
      this.CCPlaceHolder = this.achPlaceHolder = this.eftPlaceHolder ="Set AutoPay";
    } else {
      this.CCPlaceHolder = "Set Card on File";
      this.achPlaceHolder = "Set ACH on File";
      this.eftPlaceHolder = "Set EFT on File";
    }
    this.getFcilityInfoACH(this.Currentstore)
    this.getFcilityInfoEFT(this.Currentstore)
    this.getLOVList();
    this.getCountries();
    this.getStoresbyId();
    this.setMandatoryFieldHostedPage();
    this.callLinkedUnlitList();
    if (this.AutopayProfileUpdate) {
      this.patchAutopayData(this.AutopayProfileUpdate);
    }
    if (this.TenantId) {
      this.getTenantDetailsById(this.TenantId);
      if (this.paymentOrigin !== EPaymentOrigin.Rental && this.paymentOrigin !== EPaymentOrigin.Transfer) {
        this.GetAutoPayHistoryDetails(this.TenantId, this.Currentstore, false);
      }
    } else {
      if (this.tenantInfo) {
        this.customerInfoPresent = true;
        this.customerInfo = {
          FirstName: this.tenantInfo.FirstName,
          MiddleName: this.tenantInfo.MiddleName,
          LastName: this.tenantInfo.LastName,
          CompanyName: this.tenantInfo.CompanyName,
          AddressOne: this.tenantInfo.AddressOne,
          City: this.tenantInfo.City,
          CountryCode: this.tenantInfo.CountryCode,
          StateCode: this.tenantInfo.StateCode,
          StateId: this.tenantInfo.StateId,
          PostalCode: this.tenantInfo.PostalCode,
          CountryId: this.tenantInfo.CountryId,
          CellPhoneNumber: this.tenantInfo.CellPhoneNumber,
          Email: this.tenantInfo.Email,
          FullName: this.tenantInfo.FullName
        }
      }
    }
    this.wrapSettings = { wrapMode: 'Both' };
    this.checkautoPay = this.checkautoPay || this.isAutoPayRequired;
    this.setInitialAutopayData();
  }

  generateLeaseNumber() {
    const datepipe: DatePipe = new DatePipe('en');
    const date = new Date();
    const dateStr = datepipe.transform(date, 'yyMMddHHmmssSSS');
    return parseInt(dateStr, 10);
  }

  createRCMALIAS(orderId) {
    if (this.credentials == null) {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.warning('We could not process your Autopay for this facility, Please contact Administrator!', 'Please try a different Payment method', this.toasterConfig);
      this.setAutopayStatusObj('Reset');
    } else {
      this.loaderIcon = Promise.resolve(false);
      if (!this.credentials.RCMURL) {
        this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.setAutopayStatusObj('Reset');
      } else {
        this.loaderIconTD = Promise.resolve(true);
        this.initiatedVoidCC = true;
        this.disablesavebutton = false;
        const reqParam = "<REQUEST>" +
          "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
          "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
          "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
          "<TRANSACTIONTYPE>ALIASCREATE</TRANSACTIONTYPE>" + "<ORDERID>" + orderId + "</ORDERID></REQUEST>";
        this.paymentService.getRCMService(this.credentials.RCMURL, reqParam).subscribe((res: any) => {
          const resultFromRCM = res;
          const responseData = JSON.parse(resultFromRCM.RcmResponse);
          if (responseData != null && responseData.RESPONSE != null && responseData.RESPONSE.RESULTMSG == "Function failed.  Device initialization error") {
            this.toastr.warning('Please connect the device ', 'Device Required', this.toasterConfig);
            this.setAutopayStatusObj('Failed');
            this.autopayFailed = true;
            this.autopayFailReason = responseData.RESPONSE.RESULTMSG;
            this.initiatedVoidCC = false;
            this.loaderIconTD = Promise.resolve(false);
            this.saveOpenEdgeCCTransaction(responseData.RESPONSE, EPaymentModes.CreditCard, this.autopayFailReason, EPaymentTransactionType.Declined);
          } else if (responseData.RESPONSE.RESULT == 0) {
            this.setAutopayStatusObj('Success');
            this.emitAliaseKey = responseData.RESPONSE.ALIAS;
            this.cardNumber = responseData.RESPONSE.ACCOUNT;
            this.expYear = responseData.RESPONSE.EXPYEAR;
            this.expMonth = responseData.RESPONSE.EXPMONTH;
            this.nameOnCard = responseData.RESPONSE.CARDHOLDERNAME;
            var cType = responseData.RESPONSE.CARDBRAND;
            this.cTypeId = this.paymentService.openEdgeCardType(cType);
            this.process = true;
            this.initiatedVoidCC = false;
            this.loaderIconTD = Promise.resolve(false);
            this.saveOpenEdgeCCTransaction(responseData.RESPONSE, EPaymentModes.CreditCard, responseData.RESPONSE.HOSTRESPONSEDESCRIPTION, EPaymentTransactionType.Processed);
          } else {
            this.setAutopayStatusObj('Failed');
            this.initiatedVoidCC = false;
            this.autopayFailed = true;
            this.autopayFailReason = responseData?.RESPONSE?.RESULTMSG ?? 'Declined';
            this.loaderIcon = Promise.resolve(false);
            this.loaderIconTD = Promise.resolve(false);
            this.saveOpenEdgeCCTransaction(responseData.RESPONSE, EPaymentModes.CreditCard, this.autopayFailReason, EPaymentTransactionType.Declined);
          }
        }, err => {
          this.toastr.warning('Please connect the device ', 'Device Required', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
          this.loaderIconTD = Promise.resolve(false);
          this.setAutopayStatusObj('Reset');
          this.initiatedVoidCC = false;
          this.autopayFailReason = 'Device Not Connected!';
          this.autopayFailed = this.disablesavebutton = true;
          this.saveOpenEdgeCCTransaction(null, EPaymentModes.CreditCard, err?.statusText ?? this.autopayFailReason, EPaymentTransactionType.Declined);
        }
        );
      }
    }
  }

  emitResponse(onDelete) {
    if (this.isPayFieldsEnrollmentPending || this.showPayFieldsCardOnFileForm) return;
    let maxlengthName = 30;
    let maxlengthAddress = 50;
    let maxlengthZip = 15;
    this.loaderIcon = Promise.resolve(true);

    let obj = {
      checked: this.checkautoPay,
      response: this.emitAliaseKey,
      cardNumber: this.cardNumber,
      zipCode: this.zipCode && this.zipCode.length > maxlengthZip ? this.zipCode.substr(0, maxlengthZip) : this.zipCode,
      address: this.Address && this.Address.length > maxlengthAddress ? this.Address.substr(0, maxlengthAddress) : this.Address,
      nameOnCard: this.nameOnCard && this.nameOnCard.length > maxlengthName ? this.nameOnCard.substr(0, maxlengthName) : this.nameOnCard,
      expMonth: this.modeSelect == 'ACH' || this.modeSelect == 'EFT' ? null : parseInt(this.expMonth, 10),
      expYear: this.expYear,
      cardType: this.modeSelect == 'ACH' || this.modeSelect == 'EFT' ? null : this.cTypeId,
      autoCcDays: this.autoCCDays,
      transitNo: this.transitNo,
      Accountnumber: this.Accountnumber,
      AccountName: this.Accountname,
      bankcode: this.bankcode,
      email: this.email,
      printAutopay: this.printAutopay,
      eftform: this.EFTForm,
      ACHRoutingNo: this.ACHRoutingNo,
      ACHaccountno: this.ACHaccountno,
      ACHaccountclass: this.ACHaccountclass,
      ACHaccounttype: this.ACHaccounttype,
      ACHForm: this.ACHForm,
      SeriesId: this.paymentGateWay == EPaymentGateway.TdBank && this.cofSeriesIdRes && this.cofSeriesIdRes.card_on_file ? this.cofSeriesIdRes.card_on_file.series_id : null,
      ACHPaymentAccountId: this.ACHForm && this.emitAliaseKey ? this.emitAliaseKey : null,
      PaymentAccountId: (this.CardTerminalForm || this.CardWebsiteForm) && this.emitAliaseKey ? this.emitAliaseKey : null,
      AutopayLinkedUnitLeaseNoList: this.enableLinkedUnitLeaseNo,
      CustomerId: this.customerId
    }
    this.autopaydata = obj;
    let ccObj;
    if (this.autopaydata) {
      if (this.autopaydata.checked && (this.CardTerminalForm || this.CardWebsiteForm) && !this.autopaydata.response) {
        ccObj = {
          LeaseNo: this.leaseNo,
          FacilityId: this.Currentstore,
          Autopay: false,
          AutoCcProcessingDay: this.CardTerminalForm || this.CardWebsiteForm ? this.autopaydata.autoCcDays : null,
          CreditCardNumber: this.autopaydata.cardNumber ? this.autopaydata.cardNumber : null,
          CreditCardType: this.autopaydata.cardType ? this.autopaydata.cardType : null,
          NameonCard: this.autopaydata.nameOnCard ? this.autopaydata.nameOnCard : null,
          CreditCardExpiryMonth: this.modeSelect == 'ACH' || this.modeSelect == 'EFT' ? null : (this.getExpiryMonthValue(this.autopaydata.expMonth) ? this.getExpiryMonthValue(this.autopaydata.expMonth) : null),
          CreditCardExpiryYear: this.autopaydata.expYear ? this.autopaydata.expYear : null,
          CreditCardBillingAddress: this.autopaydata.address ? this.autopaydata.address : null,
          CreditCardBillingZip: this.autopaydata.zipCode ? this.autopaydata.zipCode : null,
          PaymentAccountId: (this.CardTerminalForm || this.CardWebsiteForm) && this.autopaydata.response ? this.autopaydata.response : null,
          ACHPayment: this.ACHForm ? this.autopaydata.checked : false,
          ACHProcessingDay: this.ACHForm ? this.autopaydata.autoCcDays : null,
          DirectDebit: this.EFTForm || this.selectedPaymentMode == EPaymentModes.DirectDebitEFT ? this.autopaydata.checked : false,
          DirectDebitProcessingDay: this.EFTForm ? this.autopaydata.autoCcDays : null,
          ACHAccountNo: this.autopaydata.ACHaccountno ? this.autopaydata.ACHaccountno : null,
          ACHRoutingNo: this.autopaydata.ACHRoutingNo ? this.autopaydata.ACHRoutingNo : null,
          ACHAccountClass: this.autopaydata.ACHaccountclass ? this.autopaydata.ACHaccountclass : null,
          ACHAccountType: this.autopaydata.ACHaccounttype ? this.autopaydata.ACHaccounttype : null,
          AccountHolder: this.autopaydata.AccountName ? this.autopaydata.AccountName : null,
          BankCode: this.autopaydata.bankcode ? this.autopaydata.bankcode : null,
          TransitNo: this.autopaydata.transitNo ? this.autopaydata.transitNo : null,
          BankAccountNo: this.autopaydata.Accountnumber ? this.autopaydata.Accountnumber : null,
          EmailPaymentReceipt: this.autopaydata.email ? this.autopaydata.email : false,
          PrintPaymentReceipt: this.autopaydata.printAutopay ? this.autopaydata.printAutopay : false,
          SeriesId: this.paymentGateWay == EPaymentGateway.TdBank && this.cofSeriesIdRes && this.cofSeriesIdRes.card_on_file ? this.cofSeriesIdRes.card_on_file.series_id : null,
          ACHPaymentAccountId: this.ACHForm && this.autopaydata.checked ? this.autopaydata.response : null,
          AutopayLinkedUnitLeaseNoList: this.autopaydata.AutopayLinkedUnitLeaseNoList,
          MandateId: this.mandateId,
          IsStripe: this.paymentGateWay == EPaymentGateway.Stripe ? true : false,
          TransactionTypeId: this.paymentService.GetTransactionTypeId(this.paymentOrigin),
          CustomerId: this.customerId
        }
      } else {
        ccObj = {
          LeaseNo: this.leaseNo,
          FacilityId: this.Currentstore,
          Autopay: this.CardTerminalForm || this.CardWebsiteForm ? this.autopaydata.checked : false,
          AutoCcProcessingDay: this.CardTerminalForm || this.CardWebsiteForm ? this.autopaydata.autoCcDays : null,
          CreditCardNumber: this.autopaydata.cardNumber ? this.autopaydata.cardNumber : null,
          CreditCardType: this.autopaydata.cardType ? this.autopaydata.cardType : null,
          NameonCard: this.autopaydata.nameOnCard ? this.autopaydata.nameOnCard : null,
          CreditCardExpiryMonth: this.modeSelect == 'ACH' || this.modeSelect == 'EFT' ? null : (this.getExpiryMonthValue(this.autopaydata.expMonth) ? this.getExpiryMonthValue(this.autopaydata.expMonth) : null),
          CreditCardExpiryYear: this.autopaydata.expYear ? this.autopaydata.expYear : null,
          CreditCardBillingAddress: this.autopaydata.address ? this.autopaydata.address : null,
          CreditCardBillingZip: this.autopaydata.zipCode ? this.autopaydata.zipCode : null,
          PaymentAccountId: (this.CardTerminalForm || this.CardWebsiteForm) && this.autopaydata.response ? this.autopaydata.response : null,
          ACHPayment: this.ACHForm ? this.autopaydata.checked : false,
          ACHProcessingDay: this.ACHForm ? this.autopaydata.autoCcDays : null,
          DirectDebit: this.EFTForm || this.selectedPaymentMode == EPaymentModes.DirectDebitEFT ? this.autopaydata.checked : false,
          DirectDebitProcessingDay: this.EFTForm ? this.autopaydata.autoCcDays : null,
          ACHAccountNo: this.autopaydata.ACHaccountno ? this.autopaydata.ACHaccountno : null,
          ACHRoutingNo: this.autopaydata.ACHRoutingNo ? this.autopaydata.ACHRoutingNo : null,
          ACHAccountClass: this.autopaydata.ACHaccountclass ? this.autopaydata.ACHaccountclass : null,
          ACHAccountType: this.autopaydata.ACHaccounttype ? this.autopaydata.ACHaccounttype : null,
          AccountHolder: this.autopaydata.AccountName ? this.autopaydata.AccountName : null,
          BankCode: this.autopaydata.bankcode ? this.autopaydata.bankcode : null,
          TransitNo: this.autopaydata.transitNo ? this.autopaydata.transitNo : null,
          BankAccountNo: this.autopaydata.Accountnumber ? this.autopaydata.Accountnumber : null,
          EmailPaymentReceipt: this.autopaydata.email ? this.autopaydata.email : false,
          PrintPaymentReceipt: this.autopaydata.printAutopay ? this.autopaydata.printAutopay : false,
          SeriesId: this.paymentGateWay == EPaymentGateway.TdBank && this.cofSeriesIdRes && this.cofSeriesIdRes.card_on_file ? this.cofSeriesIdRes.card_on_file.series_id : null,
          ACHPaymentAccountId: this.ACHForm && this.autopaydata.response ? this.autopaydata.response : null,
          AutopayLinkedUnitLeaseNoList: this.autopaydata.AutopayLinkedUnitLeaseNoList,
          MandateId: this.mandateId,
          IsStripe: this.paymentGateWay == EPaymentGateway.Stripe ? true : false,
          TransactionTypeId: this.paymentService.GetTransactionTypeId(this.paymentOrigin),
          CustomerId: this.customerId
        }
      }

      if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate].includes(this.paymentOrigin)) {
        this.transferdataservice.pastdueautopay = ccObj;
        this.facOpsDataService.saveautopay = ccObj;
        this.customerDataService.customerAutoPayDetails = ccObj;
        this.setInitialAutopayData();
      } else {
        if (!onDelete) {
          this.saveAutoPayData(ccObj);
        }
      }
    }
    let autopayObj = {
      Enabled: this.checkautoPay,
      AutoCC: this.CardWebsiteForm || this.CardTerminalForm ? true : false,
      AutoACH: this.ACHForm,
      Processed: this.process,
      LinkedleaseNo : this.enableLinkedUnitLeaseNo
    }
    this.facOpsDataService.autoPayData = autopayObj;
    if (this.autopayFailed == true && this.paymentGateWay == EPaymentGateway.TdBank) {
      this.autopayFailed = false;
      this.checkautoPay = false;
      this.tdNameOnCard = '';
      this.tdFName = '';
      this.tdLName = '';
      this.tdEmail = '';
      this.tdAddress = '';
      this.tdCity = '';
      this.tdZip = '';
      this.tdCellphone = '';
    }
    if (this.resetPostPayment) {
      this.autopayCompleted.emit(true);
    }
  }

  createCNPALIAS() {
    this.loaderIconAuto = Promise.resolve(true);
    this.disablesavebutton = true;
    if (this.credentials == null) {
      this.toastr.warning('We could not process your Autopay for this facility, Please contact Administrator!', 'Please try a different Payment method', this.toasterConfig);
      this.setAutopayStatusObj('Reset');
    } else {
      if (!this.credentials.CardNotPresentURL) {
        this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
        this.loaderIconAuto = Promise.resolve(false);
        this.setAutopayStatusObj('Reset');
      } else {
        //let rqsturl = 'https://ee.test.paygateway.com/HostPayService/v1/hostpay/transactions/';
        if (this.isAutoPopulateBillingInfo && this.customerInfo) {
          this.setCNPCustomerInfo();
        } else {
          this.requestParam = "<REQUEST>" +
            "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
            "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
            "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
            "<TRANSACTIONTYPE>CREDITAUTH</TRANSACTIONTYPE>" +
            "<AMOUNT>0</AMOUNT>" +
            "<ORDERID>" + this.OrderId + "</ORDERID>" +
            "<CREATEALIAS>TRUE</CREATEALIAS>" +
            "<HOSTPAYSETTING>" +
            "<CARDBRAND>" + this.facilityCreditCards + "</CARDBRAND>" +
            "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
            "<CUSTOMIZATION>" +
            "<PAGE> " +
            this.openEdgeBillingFields +
            "</PAGE>" +
            "<BRANDING>" +
            "<BODY>" +
            "<FONT-FAMILY> LATO,SANS-SERIF;</FONT-FAMILY>" +
            "<FONT-SIZE>14px</FONT-SIZE>" +
            "</BODY>" +
            "<BTN>" +
            "<BACKGROUND-COLOR>#3757C5;</BACKGROUND-COLOR>" +
            "<FONT-SIZE>14PX;</FONT-SIZE>" +
            "</BTN>" +
            "<SPECIALCSS>" +
            "<SECTION-HEADER-FONT-SIZE>18px</SECTION-HEADER-FONT-SIZE>" +
            "<COLOR>#3757C5;</COLOR>" +
            "</SPECIALCSS>" +
            "</BRANDING>" +
            "</CUSTOMIZATION>" +
            "<POSDEVICE>" +
            "<TYPE>KEYED</TYPE>" +
            "</POSDEVICE>" +
            "</HOSTPAYSETTING>" +
            "</REQUEST>";
        }
        this.paymentService.getCNPService(this.credentials.CardNotPresentURL, this.requestParam).subscribe((res: any) => {
          this.loaderIconAuto = Promise.resolve(false);
          this.AliaseIFrame.show();
          this.showAliasIFrame = true;
          const resultResponse = JSON.parse(res);
          this.urlSafeAlias = this.sanitizer.bypassSecurityTrustResourceUrl(resultResponse.RESULT.PAYPAGEURL);
          this.disablesavebutton = false;
          setTimeout(() => {
          }, 500);
        }, err => {
          this.autopayFailed = true;
          this.setAutopayStatusObj('Reset');
          this.toastr.error('Failed to receive CNP Response URL', 'Error', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
        });
      }
    }
  }

  // ── PayFields Card on File: standalone enrollment (no active payment) ──────
  // Mirrors payment.component.ts's embedded PayFields tokenization lifecycle, scoped to the
  // Modify Rental / Rental / Transfer / MakePayment "Add Card On Websites" autopay flow.
  private hasCredentialValue(value: any): boolean {
    return !!(value ?? '').toString().trim();
  }

  private isOpenEdgePayFieldPaymentEnabled(): boolean {
    const value = this.credentials?.EnablePayFieldPayment ?? this.credentials?.EnabledPayFieldPayment;
    return value === true || (typeof value === 'number' && value !== 0)
      || (typeof value === 'string' && value.trim().toLowerCase() === 'true');
  }

  private getPayFieldsTokenizationApiKey(): string {
    return [this.credentials?.PayFieldsAPIKey, this.credentials?.PayFieldApiKey]
      .find((value) => this.hasCredentialValue(value)) ?? '';
  }

  private getPayFieldsEnvironment(): string {
    const raw = ([this.credentials?.PayFieldEnvironment, this.credentials?.PayFieldModeAddOn, this.credentials?.Environment]
      .find((value) => this.hasCredentialValue(value)) ?? 'test').toString().trim().toLowerCase();
    if (['local', 'dev', 'pqa', 'qa', 'test', 'prod'].includes(raw)) {
      return raw;
    }
    return raw === 'production' ? 'prod' : 'test';
  }

  canUseOpenEdgePayFieldsRuntime(): boolean {
    if (!this.isOpenEdgePayFieldPaymentEnabled()) {
      return false;
    }
    return this.hasCredentialValue(this.credentials?.PAYFIELDSXWEBID)
      && this.hasCredentialValue(this.credentials?.PAYFIELDSXWEBTERMINALID)
      && this.hasCredentialValue(this.credentials?.PAYFIELDSXWEBAUTHKEY)
      && [this.credentials?.PAYFIELDAPIAuthURL, this.credentials?.PayFieldAuthURL,
        this.credentials?.PAYFIELDSAPIIntegrationURL, this.credentials?.PayFieldIntegrationURL].some(value => this.hasCredentialValue(value))
      && [this.credentials?.ApiKey, this.credentials?.PayFieldApiKey, this.credentials?.PAYFIELDSTRANSACTIONSAPIKEY].some(value => this.hasCredentialValue(value))
      && [this.credentials?.ApiSecret, this.credentials?.PayFieldApiSecret, this.credentials?.PAYFIELDSTRANSACTIONSAPISECRET].some(value => this.hasCredentialValue(value))
      && this.hasCredentialValue(this.getPayFieldsTokenizationApiKey());
  }

  openPayFieldsCardOnFileForm(): void {
    if (this.payFieldsDestroyed || this.showPayFieldsCardOnFileForm || this.isPayFieldsEnrollmentPending) return;
    this.payFieldsPreviousFocus = document.activeElement as HTMLElement;
    const attempt = ++this.payFieldsEnrollmentAttempt;
    this.payFieldsEnrollmentContext = { facilityId: this.Currentstore, leaseNo: this.leaseNo, selectedUnitLease: this.selectedUnitLease };
    this.showPayFieldsCardOnFileForm = true;
    this.isPayFieldsCardOnFileFormReady = false;
    this.payFieldsCardOnFileTokenizationResult = null;
    this.payFieldsCardOnFileCardValidity = { number: false, expiration: false, cvv: false };
    this.onPayFieldsCardOnFileAutoPopulateChange();
    setTimeout(() => {
      if (this.isCurrentPayFieldsEnrollment(attempt)) this.initializePayFieldsCardOnFileForm();
    }, 0);
  }

  private resetPayFieldsCardOnFileBillingDetails(): void {
    this.payFieldsCardOnFileBillingDetails = {
      firstName: '',
      middleName: '',
      lastName: '',
      companyName: '',
      addressOne: '',
      addressTwo: '',
      city: '',
      postalCode: '',
      countryId: environment.defaultCountryId,
      stateId: 0
    };
    this.onPayFieldsCardOnFileCountryChange(this.payFieldsCardOnFileBillingDetails.countryId);
  }

  onPayFieldsCardOnFileCountryChange(id, preferredStateId?: number): void {
    const request = ++this.payFieldsStateRequest;
    const context = this.payFieldsEnrollmentContext;
    this.stateList = [];
    this.payFieldsCardOnFileBillingDetails.stateId = 0;
    if (id == 1 || id == 2) {
      this.emptyStateList = false;
      this.generalService.getStates(id).subscribe((response: IState[]) => {
        if (request !== this.payFieldsStateRequest || context !== this.payFieldsEnrollmentContext
          || !this.showPayFieldsCardOnFileForm || this.payFieldsCardOnFileBillingDetails.countryId != id) return;
        this.stateList = response;
        this.payFieldsCardOnFileBillingDetails.stateId = response.some(state => state.Id == preferredStateId)
          ? preferredStateId : (response.length > 0 ? response[0].Id : 0);
      }, () => {
        if (request === this.payFieldsStateRequest && context === this.payFieldsEnrollmentContext && this.showPayFieldsCardOnFileForm) {
          this.toastr.error('Unable to load states. Please select the country again.', 'PayFields Error', this.toasterConfig);
        }
      });
    } else {
      this.emptyStateList = true;
      this.stateList = [];
      this.payFieldsCardOnFileBillingDetails.stateId = 0;
    }
  }

  onPayFieldsCardOnFileAutoPopulateChange(): void {
    if (!this.isAutoPopulateBillingInfo || !this.customerInfo) {
      this.resetPayFieldsCardOnFileBillingDetails();
      return;
    }

    this.payFieldsCardOnFileBillingDetails = {
      firstName: this.customerInfo.FirstName || '',
      middleName: this.customerInfo.MiddleName || '',
      lastName: this.customerInfo.LastName || '',
      companyName: this.customerInfo.CompanyName || '',
      addressOne: this.customerInfo.AddressOne || this.tenantModel?.Address || '',
      addressTwo: '',
      city: this.customerInfo.City || this.tenantModel?.City || '',
      postalCode: this.customerInfo.PostalCode || this.tenantModel?.Zip || '',
      countryId: this.customerInfo.CountryId || environment.defaultCountryId,
      stateId: this.customerInfo.StateId || this.tenantModel?.State?.Id || 0
    };
    this.onPayFieldsCardOnFileCountryChange(this.payFieldsCardOnFileBillingDetails.countryId, this.payFieldsCardOnFileBillingDetails.stateId);
  }

  private initializePayFieldsCardOnFileForm(): void {
    if (!this.showPayFieldsCardOnFileForm || this.payFieldsCardOnFileSecureForm) {
      return;
    }
    const attempt = this.payFieldsEnrollmentAttempt;
    this.payFieldsSdkLoader.load()
      .then(() => {
        if (this.isCurrentPayFieldsEnrollment(attempt)) this.buildPayFieldsCardOnFileForm();
      })
      .catch(() => {
        if (!this.isCurrentPayFieldsEnrollment(attempt)) return;
        this.toastr.error('GlobalPayments SDK is not available.', 'PayFields Error', this.toasterConfig);
      });
  }

  private buildPayFieldsCardOnFileForm(): void {
    if (!this.showPayFieldsCardOnFileForm || this.payFieldsCardOnFileSecureForm) {
      return;
    }
    const tokenizationApiKey = this.getPayFieldsTokenizationApiKey();
    if (!tokenizationApiKey) {
      this.toastr.error('PayFields API key is missing in gateway settings.', 'PayFields Error', this.toasterConfig);
      return;
    }
    try {
      GlobalPayments.configure({
        'X-GP-Api-Key': tokenizationApiKey,
        'X-GP-Environment': this.getPayFieldsEnvironment()
      });
      this.payFieldsCardOnFileSecureForm = GlobalPayments.ui.form({
        fields: {
          'card-number': { target: '#payfields-cof-card-number', placeholder: 'Card Number', required: true },
          'card-expiration': { target: '#payfields-cof-card-expiration', placeholder: 'MM / YYYY', required: true },
          'card-cvv': { target: '#payfields-cof-card-cvv', placeholder: 'CVV', required: true },
          submit: { target: '#payfields-cof-submit-host', text: 'Submit' }
        },
        styles: {
          input: {
            border: '0px', outline: 'none', 'box-shadow': 'none', background: 'transparent',
            'font-size': '14px', 'font-family': 'Lato, sans-serif', color: '#2a2a2a', 'line-height': '20px'
          },
          'input:focus': { border: '0px', outline: 'none', 'box-shadow': 'none' },
          '::placeholder': { color: '#6c757d' }
        }
      });
      this.watchPayFieldsCardOnFileIframes();
      const form = this.payFieldsCardOnFileSecureForm;
      form.frames['card-number']?.on('card-number-test', (result: any) => {
        if (form !== this.payFieldsCardOnFileSecureForm) return;
        this.payFieldsCardOnFileCardValidity.number = result?.valid === true;
      });
      form.frames['card-expiration']?.on('card-expiration-test', (result: any) => {
        if (form !== this.payFieldsCardOnFileSecureForm) return;
        this.payFieldsCardOnFileCardValidity.expiration = result?.valid === true;
      });
      form.frames['card-cvv']?.on('card-cvv-test', (result: any) => {
        if (form !== this.payFieldsCardOnFileSecureForm) return;
        this.payFieldsCardOnFileCardValidity.cvv = result?.valid === true;
      });
      form.ready(() => {
        if (form !== this.payFieldsCardOnFileSecureForm) return;
        this.isPayFieldsCardOnFileFormReady = true;
      });
    } catch (error) {
      this.payFieldsCardOnFileIframeObserver?.disconnect();
      this.payFieldsCardOnFileIframeObserver = null;
      this.toastr.error('Unable to initialize PayFields form.', 'PayFields Error', this.toasterConfig);
    }
  }

  private watchPayFieldsCardOnFileIframes(): void {
    this.payFieldsCardOnFileIframeObserver?.disconnect();
    this.payFieldsCardOnFileIframeObserver = null;
    const container = this.payFieldsCardOnFileDialogElement;
    if (!container) return;

    const fixIframeSrc = (iframe: HTMLIFrameElement) => {
      if (iframe.src && iframe.src.startsWith(location.origin + '/SecureSubmit.v1/')) {
        iframe.src = iframe.src.replace(location.origin, 'https://js.paygateway.com');
      }
    };
    const fixIframesInNode = (node: Node) => {
      if (node instanceof HTMLIFrameElement) fixIframeSrc(node);
      if (node instanceof Element) {
        node.querySelectorAll('iframe').forEach((iframe: HTMLIFrameElement) => fixIframeSrc(iframe));
      }
    };

    fixIframesInNode(container);
    this.payFieldsCardOnFileIframeObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => fixIframesInNode(node));
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLIFrameElement) {
          fixIframeSrc(mutation.target);
        }
      }
    });
    this.payFieldsCardOnFileIframeObserver.observe(container, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['src']
    });
  }

  isPayFieldsCardOnFileCustomerInfoValid(): boolean {
    const country = this.countryList?.find(item => item.Id == this.payFieldsCardOnFileBillingDetails.countryId);
    return !!(
      this.payFieldsMandatoryFieldsLoaded &&
      this.payFieldsCardOnFileBillingDetails.firstName?.trim() &&
      this.payFieldsCardOnFileBillingDetails.lastName?.trim() &&
      this.payFieldsCardOnFileBillingDetails.addressOne?.trim() &&
      this.payFieldsCardOnFileBillingDetails.city?.trim() &&
      this.payFieldsCardOnFileBillingDetails.countryId && country?.IsoCode?.trim() &&
      (this.emptyStateList ||
        (!this.payFieldsStateRequired && (!this.payFieldsCardOnFileBillingDetails.stateId || this.payFieldsCardOnFileBillingDetails.stateId == 0)) ||
        this.stateList?.some((item) => item.Id == this.payFieldsCardOnFileBillingDetails.stateId && item.Code?.trim())) &&
      this.payFieldsCardOnFileBillingDetails.postalCode?.trim()
    );
  }

  isPayFieldsCardOnFileSubmitDisabled(): boolean {
    return this.isPayFieldsEnrollmentPending || !this.isPayFieldsCardOnFileFormReady || !this.isPayFieldsCardOnFileCustomerInfoValid()
      || !this.payFieldsCardOnFileCardValidity.number || !this.payFieldsCardOnFileCardValidity.expiration
      || !this.payFieldsCardOnFileCardValidity.cvv;
  }

  submitPayFieldsCardOnFileForm(): void {
    if (!this.isCurrentPayFieldsEnrollment(this.payFieldsEnrollmentAttempt)) return;
    if (this.isPayFieldsCardOnFileSubmitDisabled() || !this.showPayFieldsCardOnFileForm) return;
    if (!this.isPayFieldsCardOnFileCustomerInfoValid()) {
      this.toastr.warning('Please complete required customer information.', 'Validation', this.toasterConfig);
      return;
    }
    if (!this.payFieldsCardOnFileSecureForm || !this.isPayFieldsCardOnFileFormReady) {
      this.toastr.warning('PayFields form is still loading. Please wait and retry.', 'Please Wait', this.toasterConfig);
      return;
    }
    this.loaderIconAuto = Promise.resolve(true);
    this.isPayFieldsEnrollmentPending = true;
    this.payFieldsTokenPending = true;
    const attempt = ++this.payFieldsEnrollmentAttempt;
    const form = this.payFieldsCardOnFileSecureForm;
    form.off?.('token-success');
    form.off?.('token-error');
    form.off?.('error');
    form.on('token-success', (result: any) => this.handlePayFieldsCardOnFileTokenResult(result, attempt));
    form.on('token-error', () => this.handlePayFieldsCardOnFileTokenResult({ error: true }, attempt));
    form.on('error', () => this.handlePayFieldsCardOnFileTokenResult({ error: true }, attempt));
    this.payFieldsTokenTimer = setTimeout(() => this.handlePayFieldsCardOnFileTokenResult({ error: true }, attempt), 30000);
    const submitFrame = form?.frames?.submit;
    if (submitFrame && submitFrame.emit) {
      try {
        submitFrame.emit('click');
      } catch {
        this.handlePayFieldsCardOnFileTokenResult({ error: true }, attempt);
      }
    } else {
      this.handlePayFieldsCardOnFileTokenResult({ error: true }, attempt);
    }
  }

  private handlePayFieldsCardOnFileTokenResult(result: any, attempt: number): void {
    if (!this.isCurrentPayFieldsEnrollment(attempt) || !this.showPayFieldsCardOnFileForm || !this.payFieldsTokenPending) return;
    this.payFieldsTokenPending = false;
    clearTimeout(this.payFieldsTokenTimer);
    const temporaryToken = (result?.paymentReference || result?.token || result?.temporary_token || '').toString().trim();
    if (!temporaryToken || result?.error) {
      this.failPayFieldsEnrollment('Card tokenization failed. Please retry.');
      return;
    }
    const billing = { ...this.payFieldsCardOnFileBillingDetails };
    const country = this.countryList?.find(item => item.Id == billing.countryId);
    if (!billing.countryId || !country?.IsoCode?.trim()) {
      this.failPayFieldsEnrollment('Please select a valid billing country and retry card setup.');
      return;
    }
    const state = this.stateList?.find(item => item.Id == billing.stateId);
    const facilityId = this.Currentstore;
    const leaseNo = this.leaseNo;
    this.startPayFieldsEnrollmentDeadline(attempt, this.OrderId);
    this.paymentService.CallPayFieldEnrollment({
      FacilityId: facilityId, Amount: 0, TemporaryToken: temporaryToken,
      OrderId: this.OrderId, InvoiceNumber: this.initialCCTOrderId?.toString(),
      FirstName: billing.firstName, MiddleName: billing.middleName, LastName: billing.lastName,
      Address1: billing.addressOne, Address2: billing.addressTwo, City: billing.city,
      PostalCode: billing.postalCode, Country: country.IsoCode.trim(), State: state?.Code || ''
    }).subscribe(response => {
      if (!this.isCurrentPayFieldsEnrollment(attempt) || !this.showPayFieldsCardOnFileForm
        || facilityId !== this.Currentstore || leaseNo !== this.leaseNo) return;
      let body: any;
      try { body = JSON.parse(response?.GatewayResponse || '{}') || {}; } catch { body = {}; }
      const token = typeof response?.ReusableToken === 'string' ? response.ReusableToken.trim() : '';
      if (!response?.Success || !response?.EnrollmentSuccess || !token || token === temporaryToken
        || [body.auth_id, body.sale_id, body.id, body.reference_id, response.ReferenceId].includes(token)) {
        this.failPayFieldsEnrollment('Card was not saved. Authorization did not return a reusable card token.');
        return;
      }
      const card = {
        emitAliaseKey: token, cardNumber: body.card?.masked_card_number || '',
        nameOnCard: `${billing.firstName} ${billing.lastName}`.trim(),
        expMonth: body.card?.expiry_month || '', expYear: body.card?.expiry_year || '',
        zipCode: billing.postalCode, Address: billing.addressOne, cTypeId: null,
        OrderId: response.ReferenceId || this.OrderId
      };
      this.getOpenEdgeCardType((body.card?.type || '').replace(/\s/g, ''), card);
      this.startPayFieldsEnrollmentDeadline(attempt, this.OrderId);
      this.saveOpenEdgeCCTransaction({
        TRANSACTIONID: body.auth_id, RESPONSECODE: EOpenEdgeResponseCode.ZeroDollarAuthApproval,
        ADDRESS1: billing.addressOne, BILLINGPOSTALCODE: billing.postalCode, CARDTYPE: 'Credit',
        PayFieldPayment: true
      }, EPaymentModes.HostedPage, 'Zero Dollar Auth Approval', EPaymentTransactionType.Processed, saved => {
        if (!this.isCurrentPayFieldsEnrollment(attempt) || !this.showPayFieldsCardOnFileForm
          || facilityId !== this.Currentstore || leaseNo !== this.leaseNo) return;
        if (!saved) {
          this.failPayFieldsEnrollment('Card authorization succeeded, but its record could not be saved. Please retry setup.');
          return;
        }
        Object.assign(this, card);
        this.CardWebsiteForm = true;
        this.CardTerminalForm = this.ACHForm = this.EFTForm = false;
        this.modeSelect = 'CardWebsite';
        this.payFieldsPreviousCard = null;
        this.process = true;
        this.autopayFailed = false;
        this.disablesavebutton = false;
        this.setAutopayStatusObj('Success');
        this.closePayFieldsCardOnFileForm();
      }, card);
    }, () => {
      if (this.isCurrentPayFieldsEnrollment(attempt)) this.failPayFieldsEnrollment('Card authorization failed. The existing saved card was not changed.');
    });
  }

  private startPayFieldsEnrollmentDeadline(attempt: number, reference?: string): void {
    clearTimeout(this.payFieldsEnrollmentTimer);
    this.payFieldsEnrollmentTimer = setTimeout(() => {
      if (!this.isCurrentPayFieldsEnrollment(attempt) || !this.isPayFieldsEnrollmentPending) return;
      const attemptReference = reference ? ` Reference: ${reference}.` : '';
      this.failPayFieldsEnrollment(`Card setup timed out; its outcome is unknown.${attemptReference} The existing saved card was not changed. Check transaction history before starting another setup.`);
    }, 60000);
  }

  private isCurrentPayFieldsEnrollment(attempt: number): boolean {
    if (this.payFieldsDestroyed || attempt !== this.payFieldsEnrollmentAttempt) return false;
    const context = this.payFieldsEnrollmentContext;
    if (context && (context.facilityId !== this.Currentstore || context.leaseNo !== this.leaseNo
      || context.selectedUnitLease !== this.selectedUnitLease)) {
      this.closePayFieldsCardOnFileForm();
      this.payFieldsPreviousCard = null;
      return false;
    }
    return true;
  }

  private failPayFieldsEnrollment(message: string): void {
    this.closePayFieldsCardOnFileForm();
    this.restorePayFieldsPreviousCard();
    this.payFieldsPreviousCard = null;
    this.isPayFieldsEnrollmentPending = false;
    this.loaderIconAuto = Promise.resolve(false);
    this.autopayFailed = true;
    this.setAutopayStatusObj('Failed');
    this.toastr.error(message, 'PayFields Error', this.toasterConfig);
  }

  private restorePayFieldsPreviousCard(): void {
    if (this.payFieldsPreviousCard) Object.assign(this, this.payFieldsPreviousCard);
  }

  onPayFieldsCardOnFileCancel(): void {
    if (this.isPayFieldsEnrollmentPending) return;
    this.closePayFieldsCardOnFileForm();
    this.restorePayFieldsPreviousCard();
    this.payFieldsPreviousCard = null;
  }

  private closePayFieldsCardOnFileForm(): void {
    this.payFieldsCardOnFileIframeObserver?.disconnect();
    this.payFieldsCardOnFileIframeObserver = null;
    this.payFieldsCardOnFileDialogElement = null;
    ++this.payFieldsEnrollmentAttempt;
    clearTimeout(this.payFieldsTokenTimer);
    clearTimeout(this.payFieldsEnrollmentTimer);
    clearTimeout(this.payFieldsFocusTimer);
    this.payFieldsFocusTrap?.destroy();
    this.payFieldsFocusTrap = null;
    const previousFocus = this.payFieldsPreviousFocus;
    this.payFieldsPreviousFocus = null;
    if (previousFocus && !this.payFieldsDestroyed) {
      this.payFieldsFocusTimer = setTimeout(() => {
        if (!this.payFieldsDestroyed && !this.showPayFieldsCardOnFileForm && previousFocus.isConnected) previousFocus.focus();
      }, 0);
    }
    this.payFieldsTokenPending = false;
    this.payFieldsEnrollmentContext = null;
    this.isPayFieldsEnrollmentPending = false;
    this.loaderIconAuto = Promise.resolve(false);
    this.loaderIconTD = Promise.resolve(false);
    this.showPayFieldsCardOnFileForm = false;
    this.isPayFieldsCardOnFileFormReady = false;
    if (this.payFieldsCardOnFileSecureForm?.dispose) {
      this.payFieldsCardOnFileSecureForm.dispose();
    }
    this.payFieldsCardOnFileSecureForm = null;
  }

  ngOnDestroy(): void {
    this.payFieldsDestroyed = true;
    this.closePayFieldsCardOnFileForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.payFieldsEnrollmentContext && ['Currentstore', 'currentLeaseNo', 'AutopayProfileUpdate'].some(key => changes[key] && !changes[key].firstChange)) {
      this.closePayFieldsCardOnFileForm();
      this.payFieldsPreviousCard = null;
    }
  }

  getFcilityInfoEFT(facilityId) {
    this.loaderIcon = Promise.resolve(true);
    this.facilityService.getFacilityInfoEFT(facilityId).subscribe((response: IEFTSettingListModel) => {
      if (response != null) {
        this.facilityInfoEFT = response;
        if (this.facilityInfoEFT.EFTSettingId) {
          this.IsEnableEFT = true;
        }
      }
      this.loaderIcon = Promise.resolve(false);
    });
  }

getFcilityInfoACH(facilityId: number): void {
  this.facilityService.getFacilityInfoACHForOp(facilityId)
    .subscribe({
      next: (response: IFacilityInfoACH) => {
        this.isEnableAch = !!response?.FacilityAchSettingsId;
      },
      error: (err) => {
        this.isEnableAch = false; 
      }
    });
}

  getHiddenInputAlias() {
    let iframeSrc = this.iframeAlias.nativeElement.src.split('/');
    let tempId = iframeSrc.pop();
    if (!this.credentials.QueryPaymentStatusURL) {
      this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
      this.setAutopayStatusObj('Reset');
    } else {
      if (this.sessionId === tempId) {
        this.loaderIcon = Promise.resolve(true);
        //let requestUrl = "https://ee.test.paygateway.com/HostPayService/v1/directpay/express";
        this.sessionId = tempId;
        const qrequestParam = "<REQUEST>" +
          "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
          "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
          "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
          " <TRANSACTIONTYPE>QUERYPAYMENT</TRANSACTIONTYPE>  <ORDERID>" + this.OrderId + "</ORDERID>" +
          "</REQUEST> ";
        this.paymentService.getCNPService(this.credentials.QueryPaymentStatusURL, qrequestParam).subscribe((res: any) => {
          const jsonResp = JSON.parse(res);
          this.AliaseIFrame.hide();
          this.loaderIcon = Promise.resolve(false);
          if (jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.ZeroDollarAuthApproval) {
            this.emitAliaseKey = jsonResp.RESULT.ALIAS;
            this.cardNumber = jsonResp.RESULT.MASKEDCARDNUMBER;
            this.zipCode = jsonResp.RESULT.BILLINGPOSTALCODE;
            this.Address = jsonResp.RESULT.ADDRESS1;
            this.nameOnCard = jsonResp.RESULT.CUSTOMERNAME;
            this.expMonth = jsonResp.RESULT.EXPMONTH;
            this.expYear = jsonResp.RESULT.EXPYEAR;
            var cType = jsonResp.RESULT.CARDBRAND;
            this.getOpenEdgeCardType(cType.replace(/\s/g, ''));
            this.process = true;
            this.saveOpenEdgeCCTransaction(jsonResp.RESULT, EPaymentModes.HostedPage, jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? 'Zero Dollar Auth Approval', EPaymentTransactionType.Processed);
            this.setAutopayStatusObj('Success');
          } else {
            this.emitAliaseKey = jsonResp.RESULT?.ALIAS ?? '';
            this.cardNumber = jsonResp.RESULT?.MASKEDCARDNUMBER ?? '';
            this.zipCode = jsonResp.RESULT?.BILLINGPOSTALCODE ?? '';
            this.Address = jsonResp.RESULT?.ADDRESS1 ?? '';
            this.nameOnCard = jsonResp.RESULT?.CUSTOMERNAME ?? '';
            this.expMonth = jsonResp.RESULT?.EXPMONTH ?? '';
            this.expYear = jsonResp.RESULT?.EXPYEAR ?? '';
            var cType = jsonResp.RESULT?.CARDBRAND ?? '';
            this.getOpenEdgeCardType(cType.replace(/\s/g, ''));
            this.saveOpenEdgeCCTransaction(jsonResp.RESULT, EPaymentModes.HostedPage, jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? 'Declined!', EPaymentTransactionType.Declined);
            this.toastr.warning('Please Try again!', 'Alert', this.toasterConfig);
            this.autopayFailed = true;
            this.setAutopayStatusObj('Failed');
          }
        }, err => {
          this.setAutopayStatusObj('Reset');
          this.AliaseIFrame.hide();
          this.loaderIcon = Promise.resolve(false);
          this.toastr.warning('Please Try again!', 'Alert', this.toasterConfig);
          this.autopayFailed = true;
          this.saveOpenEdgeCCTransaction(err?.error?.message ?? null, EPaymentModes.HostedPage, err?.error?.message ?? 'Declined!', EPaymentTransactionType.Declined);
        });
      } else {
        this.sessionId = tempId;
      }
    }
  }

  getOpenEdgeCardType(cType, card: any = this) {
    if (cType.toLowerCase() == 'americanexpress') {
      card.cTypeId = 1;
    } else if (cType.toLowerCase() == 'visa') {
      card.cTypeId = 2;
    } else if (cType.toLowerCase() == 'mastercard') {
      card.cTypeId = 3;
    } else if (cType.toLowerCase() == 'discover') {
      card.cTypeId = 4;
    } else if (cType.toLowerCase() == 'diners') {
      card.cTypeId = 5;
    } else if (cType.toLowerCase() == 'jcb') {
      card.cTypeId = 6;
    }
  }

  resetautopay() {
    this.setAutopayStatusObj('Reset');
    this.autopayFailed = false;
    this.CardTerminalForm = false;
    this.CardWebsiteForm = false;
    this.ACHForm = false;
    this.EFTForm = false;
    this.autoAchForm.reset();
    let form: NgForm = this.Eftcustomerform;
    Object.keys(form.controls).forEach(key => {
      form.controls[key].markAsUntouched();
    })

    this.checkautoPay = this.initialData && this.initialData.checkautoPay ? this.initialData.checkautoPay : false;
    this.autoCCDays = this.initialData && this.initialData.autoCCDays ? this.initialData.autoCCDays : 0;
    this.email = this.initialData && this.initialData.email ? this.initialData.email : false;
    this.printAutopay = this.initialData && this.initialData.printAutopay ? this.initialData.printAutopay : false;
    this.modeSelect = this.initialData && this.initialData.modeSelect ? this.initialData.modeSelect : 0;
    this.Accountname = this.initialEftData && this.initialEftData.Accountname ? this.initialEftData.Accountname : "";
    this.bankcode = this.initialEftData && this.initialEftData.bankcode ? this.initialEftData.bankcode : "";
    this.transitNo = this.initialEftData && this.initialEftData.transitNo ? this.initialEftData.transitNo : "";
    this.Accountnumber = this.initialEftData && this.initialEftData.Accountnumber ? this.initialEftData.Accountnumber : "";
    if (['ACH', 'CardTerminal', 'CardWebsite'].includes(this.modeSelect)) {
      this.emitAliaseKey = this.initialCcAndAchData.emitAliaseKey;
    }
    this.sendSaveResponseToModifyRental(false, false);
    if(this.isAutoPayRequired){
      this.cancelAutopay.emit(true);
    } 
  }

  setMandatoryFieldseftForm() {
    this.loaderIcon = Promise.resolve(true);
    this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, 157)
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Form.ListOfProperties.length != 0) {
          data.Form.ListOfProperties.forEach(field => {
            if (field.Required) {
              this.Eftcustomerform.form.get(field.Name).setValidators([Validators.required]);
            } else {
              this.Eftcustomerform.form.get(field.Name).setValidators(null);
            }
            this.Eftcustomerform.form.get(field.Name).updateValueAndValidity();
          });
        }
        this.loaderIcon = Promise.resolve(false);
      });
  }

  isRequired(control) {
    if (control != null) {
      if (this.Eftcustomerform.form.get(control) != null) {
        if (this.Eftcustomerform.form.get(control).validator !== null) {
          const validator = this.Eftcustomerform.form.get(control).validator({} as AbstractControl);
          return validator && validator.required ? true : false;
        } else {
          return false
        }
      }
    }
  }

  getLOVList() {
    if (this.userSessionService.lovList && this.userSessionService.lovList.length) {
      this.setListOfValuesBasedOnType();
    } else {
      this.generalService.getAllListOfValues().subscribe((response: any) => {
        if (response.length) {
          this.userSessionService.lovList = response;
          this.setListOfValuesBasedOnType();
        }
      });
    }
  }

  setListOfValuesBasedOnType() {
    this.accounttype = this.userSessionService.getLovListForType(39);
  }

  showForm(el) {
    if (this.isPayFieldsEnrollmentPending || this.showPayFieldsCardOnFileForm) return;
    if (el.target.value === 'CardWebsite' && this.paymentGateWay == EPaymentGateway.OpenEdgeExpress && this.canUseOpenEdgePayFieldsRuntime()) {
      this.payFieldsPreviousCard = {
        emitAliaseKey: this.emitAliaseKey, cardNumber: this.cardNumber, nameOnCard: this.nameOnCard,
        expMonth: this.expMonth, expYear: this.expYear, zipCode: this.zipCode, Address: this.Address,
        cTypeId: this.cTypeId, process: this.process,
        modeSelect: this.ACHForm ? 'ACH' : this.EFTForm ? 'EFT' : this.CardTerminalForm ? 'CardTerminal' : this.CardWebsiteForm ? 'CardWebsite' : '0',
        CardWebsiteForm: this.CardWebsiteForm, CardTerminalForm: this.CardTerminalForm, statusAutopay: this.statusAutopay,
        ACHForm: this.ACHForm, EFTForm: this.EFTForm, autopayFailed: this.autopayFailed
      };
      this.CardWebsiteForm = true;
      this.CardTerminalForm = this.ACHForm = this.EFTForm = false;
      this.modeSelect = 'CardWebsite';
      this.process = false;
      this.autopayFailed = false;
      this.setAutopayStatusObj('Reset');
      this.generateCCTAutopay(EPaymentModes.HostedPage);
      return;
    }
    if (this.CardTerminalForm || this.CardWebsiteForm) {
      this.lastSelection = "CC"
    } else if (this.ACHForm) {
      this.lastSelection = "ACH"
    } else if (this.EFTForm) {
      this.lastSelection = "EFT"
    }
    this.EFTForm = false;
    this.showTDForm = false;
    this.CardTerminalForm = false;
    this.CardWebsiteForm = false;
    this.process = false;
    this.ACHForm = false;
    this.autopayFailed = false;
    this.customerId = this.data?.modifyautopay?.CustomerId ?? "";
    this.emitAliaseKey = '';
    if (el.target.value === 'CardTerminal') {
      this.loaderIcon = Promise.resolve(true);
      this.CardTerminalForm = true;
      this.CardWebsiteForm = false;
      this.ACHForm = false;
      this.EFTForm = false;
      this.showTDForm = false;
      if (this.paymentGateWay == EPaymentGateway.OpenEdgeExpress) {
        this.generateCCTAutopay(EPaymentModes.CreditCard);
      } else {
        this.terminalDevicesList = this.credentials.DeviceSettings ? this.credentials.DeviceSettings : [];
        this.selectStripeReaderId = this.terminalDevicesList.find(x => x.IsPrimary).TerminalReaderId;
        this.generateCCTAutopay(EPaymentModes.CreditCard);
      }
    }
    if (el.target.value === 'CardWebsite') {
      this.CardTerminalForm = false;
      this.CardWebsiteForm = true;
      this.ACHForm = false;
      this.EFTForm = false;
      this.showTDForm = false;
      if (this.paymentGateWay == EPaymentGateway.TdBank) {
        this.isAutoPopulateBillingInfo = false;
        this.IsmodelShow = true;
        this.showTDForm = true;
        this.disableSaveButtonForTD = false;
        this.tdModalRef = this.modalService.show(this.templateTDHosted, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
        this.addJsToElement('https://libs.na.bambora.com/customcheckout/1/customcheckout.js').onload = () => {
          this.bamboraScriptForCustomChekout();
        }
      } else if (this.paymentGateWay == EPaymentGateway.OpenEdgeExpress) {
        this.showTDForm = false;
        this.generateCCTAutopay(EPaymentModes.HostedPage);
      } else if (this.paymentGateWay == EPaymentGateway.Stripe) {
        this.generateCCTAutopay(EPaymentModes.HostedPage);
      }
    } else if (el.target.value === 'ACH' || (el.target.value === 'EFT' && this.paymentGateWay == EPaymentGateway.Stripe)) {
      if (el.target.value === 'ACH' || el.target.value === 'EFT') {
        this.loaderIcon = Promise.resolve(true);
        this.selectedPaymentMode = el.target.value == 'EFT' ? EPaymentModes.DirectDebitEFT : EPaymentModes.ACH;
        this.ACHForm = true;
        this.EFTForm = false;
        this.isAutoPopulateBillingInfo = false;
        this.IsmodelShow = false;
        this.CardTerminalForm = false;
        this.CardWebsiteForm = false;
        this.showTDForm = false;
        if ([EPaymentGateway.Stripe].includes(this.paymentGateWay) || (this.achSettingPaymentGateway && el.target.value === 'ACH')) {
          this.generateIntialACH();
        }
      }
    } else if (el.target.value === 'EFT' && this.paymentGateWay != EPaymentGateway.Stripe) {
      this.setMandatoryFieldseftForm();
      this.CardTerminalForm = false;
      this.CardWebsiteForm = false;
      this.ACHForm = false;
      this.EFTForm = true;
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  generateIntialACH() {
    this.loaderIconTD = Promise.resolve(true);
    const ACHModel = {
      Amount: 0,
      Autopay: false,
      paymentModeId: 6,
      AutoACHProcessingDay: 0,
      AchAccountNumber: 0,
      AchRoutingNumber: 0,
      AccountClass: 277,
      AchAccountType: EACHAccountType.Checking,
      SwipeTransaction: false,
      AutoAchPayment: false,
      AuthorizationCode: 0,
      ResponseCode: '0',
      Reason: 'Attempting to Process',
      CcInfoPurged: false,
      OfflinePayment: false,
      ACHInfoPurged: false,
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      OrderId: null,
      FacilityId: this.Currentstore,
      TransactionDateTime: new Date(),
      TransactionTypeId: 357,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      TenantId: this.TenantId ? this.TenantId : null,
    };
    this.paymentService.saveACHTransaction(Object.assign(ACHModel)).subscribe((res: any) => {
      if (res) {
        this.initialACHOrderId = res.Id;
        if (this.paymentGateWay == EPaymentGateway.Stripe) {
          this.createSetupCardIntent(res.UniqueTransId);
        } else {
          this.loaderIcon = this.loaderIconTD = Promise.resolve(false);
          this.IsmodelShow = true;
          this.autoAchForm.patchValue({
            ACHAccounttype: this.autoAchForm.get('ACHAccounttype').value ? this.autoAchForm.get('ACHAccounttype').value : EACHAccountType.Checking
          });
          this.achModalRef = this.modalService.show(this.templateACHHosted, { class: 'modal-medium modal-dialog-centered', backdrop: 'static' });
        }
      }

    }, err => {
      this.setAutopayStatusObj('Reset');
      this.toastr.error('Failed to Set-Up Autopay', 'Error', this.toasterConfig);
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  createSetupCardIntent(uniqueOrderId) {
    const isQuickProspect = this.quickProspectTenantInfo?.IsQuickProspect;
    const obj = {
      OrderId: uniqueOrderId,
      TenantId: this.TenantId ? this.TenantId : 0,
      Name: `${this.customerInfo.FirstName}${this.customerInfo.MiddleName ? ' ' + this.customerInfo.MiddleName : ''} ${this.customerInfo.LastName}`.trim(),
      Email: this.customerInfo.Email,
      Phone: this.customerInfo.CellPhoneNumber,
      FacilityId: this.Currentstore,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      SelectedPaymentModeType: this.selectedPaymentMode === EPaymentModes.ACH ? "ACH" : this.selectedPaymentMode === EPaymentModes.DirectDebitEFT ? "EFT" : "HostedPage",
      TransactionType: 320,
      IsQuickProspectPayment: isQuickProspect,
      Customer: this.customerId
    };
    this.paymentService.SetupCardIntent(obj).subscribe((response: any) => {
      if (response) {
        this.stripeClientSecret = response.ClientSecret;
        this.stripeSetupIntent = response.SetupIntentId;
        this.callStripeHostedPage();
      } else {
        this.toastr.error('Failed to Create Payment Intent', 'Failure', this.toasterConfig);
      }
      this.loaderIconTD = Promise.resolve(false);
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.toastr.error('Failed to Create Payment Intent', 'Failure', this.toasterConfig);
      this.loaderIconTD = Promise.resolve(false);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getTDCustomerId(myIframe) {
    let url = myIframe.contentWindow.location.href;
    if (url.search('tdbank') !== -1) {
      this.emitAliaseKey = this.getParameterByName('customerCode', url);
      let responseCode = this.getParameterByName('responseCode', url);
      let responseMessage = this.getParameterByName('responseMessage', url);
      let trnOrderNumber = this.getParameterByName('trnOrderNumber', url);
      this.cardNumber = this.getParameterByName('trnCardNumber', url);
      let cardType = this.getParameterByName('cardType', url);
      let trnApproved = this.getParameterByName('trnApproved', url);
      let trnId = this.getParameterByName('trnId', url);
      let messageId = this.getParameterByName('messageId', url);
      let messageText = this.getParameterByName('messageText', url);
      let authCode = this.getParameterByName('authCode', url);
      let trnAmount = this.getParameterByName('trnAmount', url);
      let trnType = this.getParameterByName('trnType', url);
      let trnDate = this.getParameterByName('trnDate', url);
      let cvdId = this.getParameterByName('cvdId', url);
      let httpStatusCode = this.getParameterByName('httpStatusCode', url);
      let category = this.getParameterByName('category', url);
      if (cardType && cardType.toLowerCase() == 'mc') {
        this.cTypeId = 3;
      }
      this.AliaseIFrame.hide();
    }
  }

  onhstPayAliasBtn() {
    this.showAliasIFrame = false;
    this.AliaseIFrame.hide();
    this.modeSelect = 0;
    this.setAutopayStatusObj('Reset');
    this.saveOpenEdgeCCTransaction(null, EPaymentModes.HostedPage, 'Alias Cancelled By User', EPaymentTransactionType.Declined);
  }

  getExpiryMonthValue(expiryMonth) {
    let tempMonth = 263;
    if (expiryMonth) {
      if (expiryMonth > 0 && expiryMonth < 13) {
        expiryMonth = tempMonth + expiryMonth;
      } else if (expiryMonth > 263 && expiryMonth < 276) {
        expiryMonth = expiryMonth;
      } else {
        expiryMonth = 264;
      }
    } else {
      expiryMonth = 264;
    }
    return expiryMonth;
  }

    changeEnableAutoPay(event) {
    if (event.target.checked) {
      this.CCPlaceHolder = this.achPlaceHolder = "Set AutoPay";
      if (this.initialData && this.dayEndSetting) {
        this.autoCCDays = this.dayEndSetting.DefaultAutoPayDay;
      }
    } else {
       this.CCPlaceHolder = "Set Card on File";
      this.achPlaceHolder = "Set ACH on File";
      this.eftPlaceHolder = "Set EFT on File";
    }
     this.setMandatoryFieldHostedPage();
    if (!this.customerId) {
      this.customerId = this.data?.modifyautopay?.CustomerId ?? "";
    }
  }

  bamboraScriptForCustomChekout(): void {
    customcheckout = new customcheckout();
    var isCardNumberComplete = false;
    var isCVVComplete = false;
    var isExpiryComplete = false;
    var customCheckoutController = {
      init: function () {
        console.log('checkout.init()');
        this.createInputs();
        this.addListeners();
      },
      createInputs: function () {
        console.log('checkout.createInputs()');
        var options = { placeholder: '' };

        // Create and mount the inputs
        options.placeholder = 'Card number';
        customcheckout.create('card-number', options).mount('#card-number');

        options.placeholder = 'CVV';
        customcheckout.create('cvv', options).mount('#card-cvv');

        options.placeholder = 'MM / YY';
        customcheckout.create('expiry', options).mount('#card-expiry');
      },
      addListeners: function () {
        var self = this;

        // listen for submit button
        if (document.getElementById('checkout-form') !== null) {
          document
            .getElementById('checkout-form')
            .addEventListener('submit', self.onSubmit.bind(self));
        }

        customcheckout.on('brand', function (event) {
          console.log('brand: ' + JSON.stringify(event));
          document.getElementById("cardTypeTD").setAttribute('value', JSON.stringify(event));

          var cardLogo = 'none';
          if (event.brand && event.brand !== 'unknown') {
            var filePath =
              'https://cdn.na.bambora.com/downloads/images/cards/' +
              event.brand +
              '.svg';
            cardLogo = 'url(' + filePath + ')';
          }
          document.getElementById('card-number').style.backgroundImage = cardLogo;
        });

        customcheckout.on('blur', function (event) {
          console.log('blur: ' + JSON.stringify(event));
        });

        customcheckout.on('focus', function (event) {
          console.log('focus: ' + JSON.stringify(event));
        });

        customcheckout.on('empty', function (event) {
          console.log('empty: ' + JSON.stringify(event));

          if (event.empty) {
            if (event.field === 'card-number') {
              isCardNumberComplete = false;
            } else if (event.field === 'cvv') {
              isCVVComplete = false;
            } else if (event.field === 'expiry') {
              isExpiryComplete = false;
            }
            self.setPayButton(false);
          }
        });

        customcheckout.on('complete', function (event) {
          console.log('complete: ' + JSON.stringify(event));

          if (event.field === 'card-number') {
            isCardNumberComplete = true;
            self.hideErrorForId('card-number');
          } else if (event.field === 'cvv') {
            isCVVComplete = true;
            self.hideErrorForId('card-cvv');
          } else if (event.field === 'expiry') {
            isExpiryComplete = true;
            self.hideErrorForId('card-expiry');
          }

          self.setPayButton(
            isCardNumberComplete && isCVVComplete && isExpiryComplete
          );
          this.isCustomChekoutformValid = isCardNumberComplete && isCVVComplete && isExpiryComplete ? true : false;
          this.customCheckoutValid = this.isCustomChekoutformValid;
          document.getElementById("isTDFormValid").setAttribute('value', this.isCustomChekoutformValid);
        });

        customcheckout.on('error', function (event) {
          console.log('error: ' + JSON.stringify(event));

          if (event.field === 'card-number') {
            isCardNumberComplete = false;
            self.showErrorForId('card-number', event.message);
          } else if (event.field === 'cvv') {
            isCVVComplete = false;
            self.showErrorForId('card-cvv', event.message);
          } else if (event.field === 'expiry') {
            isExpiryComplete = false;
            self.showErrorForId('card-expiry', event.message);
          }
          self.setPayButton(false);
        });
      },
      onSubmit: function (event) {
        var self = this;

        console.log('checkout.onSubmit()');

        event.preventDefault();
        self.setPayButton(false);
        self.toggleProcessingScreen();

        var callback = function (result) {
          console.log('token result : ' + JSON.stringify(result));
          document.getElementById("customCardDetails").setAttribute('value', JSON.stringify(result));

          if (result.error) {
            self.processTokenError(result.error);
          } else {
            self.processTokenSuccess(result.token);
          }
        };

        console.log('checkout.createToken()');
        customcheckout.createToken(callback);
      },
      hideErrorForId: function (id) {
        console.log('hideErrorForId: ' + id);

        var element = document.getElementById(id);

        if (element !== null) {
          var errorElement = document.getElementById(id + '-error');
          if (errorElement !== null) {
            errorElement.innerHTML = '';
          }

          var bootStrapParent = document.getElementById(id + '-bootstrap');
          if (bootStrapParent !== null) {
            bootStrapParent.classList.remove('has-error');
            bootStrapParent.classList.add('has-success');
          }
        } else {
          console.log('showErrorForId: Could not find ' + id);
        }
      },
      showErrorForId: function (id, message) {
        console.log('showErrorForId: ' + id + ' ' + message);

        var element = document.getElementById(id);

        if (element !== null) {
          var errorElement = document.getElementById(id + '-error');
          if (errorElement !== null) {
            errorElement.innerHTML = message;
          }

          var bootStrapParent = document.getElementById(id + '-bootstrap');
          if (bootStrapParent !== null) {
            bootStrapParent.classList.add('has-error');
            bootStrapParent.classList.remove('has-success');
          }
        } else {
          console.log('showErrorForId: Could not find ' + id);
        }
      },
      setPayButton: function (enabled) {
        console.log('checkout.setPayButton() disabled: ' + !enabled);
        var payButton = document.getElementById('pay-button');
        if (enabled) {
          payButton['disabled'] = false;
          payButton.className = 'btn btn-primary';
          this.isCustomChekoutformValid = true;
        } else {
          payButton['disabled'] = true;
          payButton.className = 'btn btn-primary disabled';
          this.isCustomChekoutformValid = false;
        }
        document.getElementById("isTDFormValid").setAttribute('value', this.isCustomChekoutformValid);
      },
      toggleProcessingScreen: function () {
        var processingScreen = document.getElementById('processing-screen');
        if (processingScreen) {
          processingScreen.classList.toggle('visible');
        }
      },
      showErrorFeedback: function (message) {
        var xMark = '\u2718';
        this.feedback = document.getElementById('feedback');
        this.feedback.innerHTML = xMark + ' ' + message;
        this.feedback.classList.add('error');
      },
      showSuccessFeedback: function (message) {
        var checkMark = '\u2714';
        this.feedback = document.getElementById('feedback');
        this.feedback.innerHTML = checkMark + ' ' + message;
        this.feedback.classList.add('success');
      },
      processTokenError: function (error) {
        error = JSON.stringify(error, undefined, 2);
        console.log('processTokenError: ' + error);

        this.showErrorFeedback(
          'Error creating token: </br>' + JSON.stringify(error, null, 4)
        );
        this.setPayButton(true);
        this.toggleProcessingScreen();
        document.getElementById("BtnError").click();
        document.getElementById("BtnError")['disabled'] = true;
      },
      processTokenSuccess: function (token) {
        console.log('processTokenSuccess: ' + token);

        this.setPayButton(true);
        this.toggleProcessingScreen();

        // Use token to call payments api
        document.getElementById("txtTransactionId").setAttribute('value', token);
        document.getElementById("BtnPay").click();
        document.getElementById("BtnPay")['disabled'] = true;
      },
    };
    customCheckoutController.init();
  }

  createProfileTDBank(): void {
    if (this.credentials) {
      this.tdDetails = this.credentials;
    }
    let inputModel = null;
    let billingName = (this.tdFName + ' ' + this.tdLName).length > 64 ? (this.tdFName + ' ' + this.tdLName).substring(0, 64) : (this.tdFName + ' ' + this.tdLName);
    let billingAddress = this.tdAddress.length > 64 ? this.tdAddress.substring(0, 64) : this.tdAddress;
    if ((this.isMandatory('tdCountry') && !this.isMandatory('tdState')) || (!this.isMandatory('tdCountry') && this.isMandatory('tdState'))) {
      inputModel = {
        token: {
          name: this.tdNameOnCard,
          code: (<HTMLInputElement>document.getElementById('txtTransactionId')).value,
        },
        customer_code: this.UniqueIdentifier,
        validate: true,
        complete: false,
        billing: {
          name: billingName,
          email_address: this.getFirstEmailId(this.tdEmail),
          address_line1: billingAddress,
          city: this.tdCity,
          postal_code: this.tdZip,
          phone_number: this.tdCellphone
        }
      }
    } else {
      inputModel = {
        token: {
          name: this.tdNameOnCard,
          code: (<HTMLInputElement>document.getElementById('txtTransactionId')).value,
        },
        customer_code: this.UniqueIdentifier,
        validate: true,
        complete: false,
        billing: {
          name: billingName,
          email_address: this.getFirstEmailId(this.tdEmail),
          address_line1: billingAddress,
          city: this.tdCity,
          province: !this.emptyStateList && this.tdState ? this.stateList.find((item) => item.Id == this.tdState).Code : '--',
          country: this.countryList.find((item) => item.Id == this.tdCountry).IsoCode,
          postal_code: this.tdZip,
          phone_number: this.tdCellphone
        }
      }
    }
    this.generalService.createProfileTDBank(inputModel, this.tdDetails).subscribe(res => {
      let cardDetails = JSON.parse((<HTMLInputElement>document.getElementById('customCardDetails')).value);
      var cTypeDetails = JSON.parse((<HTMLInputElement>document.getElementById('cardTypeTD')).value);
      let cType = cTypeDetails.brand;
      cType = cType.replace(/\s/g, '');
      if (cType.toLowerCase() == 'amex') {
        this.cTypeId = 1;
      } else if (cType.toLowerCase() == 'visa') {
        this.cTypeId = 2;
      } else if (cType.toLowerCase() == 'mastercard') {
        this.cTypeId = 3;
      } else if (cType.toLowerCase() == 'discover') {
        this.cTypeId = 4;
      } else if (cType.toLowerCase() == 'diners') {
        this.cTypeId = 5;
      } else if (cType.toLowerCase() == 'jcb') {
        this.cTypeId = 6;
      }

      this.UpdateProfile = false;
      this.IsmodelShow = false;
      this.tdModalRef.hide();
      this.cardNumber = cardDetails ? cardDetails.last4 : 'XXXX';
      this.zipCode = this.tdZip;
      this.Address = this.tdAddress;
      this.nameOnCard = this.tdNameOnCard;
      this.expMonth = cardDetails ? this.getExpiryMonthValue(parseInt(cardDetails.expiryMonth, 10)) : 275;
      this.expYear = cardDetails ? parseInt(cardDetails.expiryYear, 10) : 2099;
      // 3D- Secure Payment 0.01$----------------------------------------    
      if (res.message == "Operation Successful") {
        this.profileResponse = res;
        this.emitAliaseKey = this.profileResponse.customer_code;
        this.browserLangauge = navigator.language;
        this.userAgent = window.navigator.userAgent;
        var req = new XMLHttpRequest();
        req.open('GET', window.location.href, false);
        req.send(null);
        this.headers = req.getResponseHeader('content-type');

        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        this.colorDepth = window.screen.colorDepth;
        this.time_zone = (new Date()).getTimezoneOffset();

        let billingInfoObj = {
          name: this.tdFName + ' ' + this.tdLName,
          address_line1: this.tdAddress,
          city: this.tdCity,
          province: !this.emptyStateList && this.tdState ? this.stateList.find((item) => item.Id == this.tdState).Code : '--',
          country: this.countryList.find((item) => item.Id == this.tdCountry).IsoCode,
          postal_code: this.tdZip,
          phone_number: this.tdCellphone,
          email_address: this.getFirstEmailId(this.tdEmail)
        }

        const threeDSecurePayment = {
          order_number: this.initialCCTOrderId,
          amount: 0.01,
          payment_method: "payment_profile",
          term_url: `${this.baseUrl}/Payments/GetCresReturnToApplication`,
          customer_ip: "::1",
          billing: billingInfoObj,
          payment_profile: {
            customer_code: res.customer_code,
            complete: false,
            "3d_secure": {
              browser: {
                accept_header: this.headers,
                java_enabled: false,
                language: this.browserLangauge,
                color_depth: this.colorDepth,
                screen_height: this.screenHeight,
                screen_width: this.screenWidth,
                time_zone: this.time_zone,
                user_agent: this.userAgent,
                javascript_enabled: true
              },
              enabled: true,
              version: 2,
              auth_required: true
            }
          }, card_on_file: {
            type: "first_recurring"
          }
        }
        this.generalService.threeDSecurePayment(threeDSecurePayment, this.tdDetails).subscribe(response => {
          // Complete the 0.00$ payment 
          if (response.message == 'Approved') {
            this.cofSeriesIdRes = response;
            this.callCompletionPayment(response, this.profileResponse.customer_code);
          } else {
            this.tdModalRef.hide();
            this.autopayFailed = true;
            this.setAutopayStatusObj('Failed');
            this.autopayFailReason = response.message;
            this.savePreAuthTransaction(response);
            this.loaderIconTD = Promise.resolve(false);
          }
        }, err => {
          if (err.status === 302 && err.error.links[0].rel === 'continue') {
            var formContents = err.error.contents;
            this.callAuthenticationForm(formContents, this.profileResponse.customer_code);
          } else {
            this.tdModalRef.hide();
            this.autopayFailed = true;
            this.setAutopayStatusObj('Failed');
            this.autopayFailReason = err.error.message;
            this.savePreAuthTransaction(err.error);
            this.loaderIconTD = Promise.resolve(false);
          }
        });
      } else {
        this.tdModalRef.hide();
        this.autopayFailed = true;
        this.setAutopayStatusObj('Failed');
        this.autopayFailReason = res.message ? res.message : "Declined";
        this.savePreAuthTransaction(res);
        this.toastr.error('Failed to create Profile', 'Error', this.toasterConfig);
        this.loaderIconTD = Promise.resolve(false);
      }
      // -------------------------------------------------------------------------------
    }, errorRes => {
      if (errorRes.error && errorRes.error.message) {
        this.toastr.error(errorRes.error.message, 'Error', this.toasterConfig);
      } else {
        this.toastr.error('Failed to create Profile', 'Error', this.toasterConfig);
      }
      this.autopayFailed = true;
      this.setAutopayStatusObj('Failed');
      this.IsmodelShow = false;
      this.tdModalRef.hide();
      this.savePreAuthTransaction(errorRes.error);
      console.log(this.CardWebsiteForm + ',' + this.autopayFailed);
      this.autopayFailReason = errorRes.error.message ? errorRes.error.message : 'Declined';
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  onPayClick() {
    this.payButton.nativeElement.click()
  }

  generateInitialCCT() {
    if (this.getUniqueIdentifier) {
      this.UniqueIdentifier = this.getUniqueIdentifier;
    } else {
      const moveInDate = this.customerDataService?.customeRentalDetails?.MoveInDate ?? new Date();
      const dateStr = this.datepipe.transform(moveInDate, 'MMddyyyy');
      let contactInfoLastName = this.customerInfo?.LastName?.replace(/[^a-zA-Z0-9]/g, "").replace(/ /g, "") ?? this.customerInfo.LastName;
      const formattedLastName = contactInfoLastName.length > 2 ? contactInfoLastName.substr(0, 3).toUpperCase()
        : contactInfoLastName.toUpperCase();
      const unitNo = this.customerDataService.customeRentalDetails.UnitNo;
      this.UniqueIdentifier = `${dateStr}-${this.facilityCode}-${formattedLastName}-${unitNo}`;
    }
    this.UniqueIdentifier = this.UniqueIdentifier.replaceAll("-", "").replaceAll(" ", "").replaceAll("'", "");
    this.generalService.checkTDProfilePresentInPortal(this.UniqueIdentifier, this.credentials).subscribe(res => {
      if (res.message == 'Operation Successful' && res.customer_code != null) {
        this.UpdateProfile = true;
        this.UpdateProfileTDBank(res.customer_code, res.card);
      } else {
        this.setAutopayStatusObj('Failed');
        this.IsmodelShow = false;
        this.tdModalRef.hide();
        this.autopayFailed = true;
        this.autopayFailReason = res.message;
        this.savePreAuthTransaction(res);
        this.toastr.warning('Something went wrong', 'Please try again!', this.toasterConfig);
        this.loaderIconTD = Promise.resolve(false);
      }
    }, err => {
      if (err.error && err.error.message == "Customer code to modify does not exist" && err.status === 404) {
        this.createProfileTDBank();
      } else {
        this.setAutopayStatusObj('Failed');
        this.IsmodelShow = false;
        this.tdModalRef.hide();
        this.autopayFailed = true;
        this.autopayFailReason = err.error && err.error.message ? err.error.message : 'Declined';
        const obj = {
          message: 'Declined'
        }
        this.savePreAuthTransaction(err.error && err.error.message ? err.error.message : obj);
        this.toastr.error('Failed to Create Profile', 'Error', this.toasterConfig);
        this.loaderIconTD = Promise.resolve(false);
      }
    });

  }


  getCountries() {
    this.generalService.getCountries().subscribe((response: ICountry[]) => {
      this.countryList = response;
      this.mapCountryIsoCode()
      this.tdCountry = environment.defaultCountryId;
      this.achCountry = environment.defaultCountryId;
      this.onCountryChange(this.tdCountry, 1)
    });
  }

  getStoresbyId() {
    this.facilityService.getFacilityInfoForOp(this.Currentstore).subscribe((response: IFacilityInfo) => {
      if (response) {
        this.countryId = response.CountryId;
        this.facilityCode = response.Code;
      }
    });
  }

  onCountryChange(id, type) {
    if (id == 1 || id == 2) {
      this.emptyStateList = false;
      this.getStates(id, type);
    } else {
      this.emptyStateList = true;
      this.stateList = [];
      this.tdState = '0';
      this.achState = '0';
    }
  }

  getStates(id, type) {
    this.generalService.getStates(id).subscribe((response: IState[]) => {
      this.stateList = response;
      if (type == 1) {
        if (this.stateList.length > 0) {
          if (this.tenantModel?.CountryId == id || this.customerInfo.CountryId == id) {
            const stateId = this.customerInfo.StateId || this.tenantModel?.State.Id;
            const state = this.stateList.find(item => item.Id == stateId);
            this.tdState = state ? state.Id : this.stateList[0].Id;
            this.achState = state ? state.Id : this.stateList[0].Id;
          } else {
            this.tdState = response[0].Id;
            this.achState = response[0].Id;
          }

        } else {
          this.tdState = 0;
          this.achState = 0;
        }
      }
    });
  }

  ontTDHostedCancel() {
    this.tdModalRef.hide();
    this.IsmodelShow = false;
    this.modeSelect = 0;
    this.setAutopayStatusObj('Reset');
    this.tdNameOnCard = '';
    this.tdFName = '';
    this.tdLName = '';
    this.tdEmail = '';
    this.tdAddress = '';
    this.tdCity = '';
    this.tdZip = '';
    this.tdCellphone = '';
    this.isAutoPopulateBillingInfo = false;
    this.tdCountry = environment.defaultCountryId;
    this.onCountryChange(this.tdCountry, 1);
  }

  onAchHostedPageCancel() {
    this.setAutopayStatusObj('Reset');
    this.achModalRef.hide();
    this.IsmodelShow = false;
    this.modeSelect = 0;
    this.tdNameOnCard = '';
    this.achFirstName = '';
    this.achLastName = '';
    this.achAddress = '';
    this.achCity = '';
    this.autoAchForm.reset();
    this.isAutoPopulateBillingInfo = false;
    this.achCountry = environment.defaultCountryId;
    this.onCountryChange(this.tdCountry, 1);
    this.saveAchTransactions(null, EPaymentTransactionType.Declined, 'Auto ACH Cancelled By User!', EPaymentModes.ACH)
  }

  onClickSave() {
    this.isAutoPayRequired = false;
    if ((this.process || this.checkautoPay) && ((!this.EFTForm && this.paymentGateWay == EPaymentGateway.OpenEdgeExpress) || this.paymentGateWay == EPaymentGateway.Stripe) && this.autopayLinledUnitList.length > 0) {
      this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered ', backdrop: 'static', keyboard: false });
    } else {
      this.emitResponse(false);
    }
  }

  generateCCTAutopay(paymentModeId) {
    const payFields = paymentModeId == EPaymentModes.HostedPage && this.paymentGateWay == EPaymentGateway.OpenEdgeExpress
      && this.canUseOpenEdgePayFieldsRuntime();
    if (payFields && (this.isPayFieldsEnrollmentPending || this.payFieldsDestroyed)) return;
    const attempt = payFields ? ++this.payFieldsEnrollmentAttempt : 0;
    if (payFields) {
      this.isPayFieldsEnrollmentPending = true;
      this.payFieldsEnrollmentContext = { facilityId: this.Currentstore, leaseNo: this.leaseNo, selectedUnitLease: this.selectedUnitLease };
      this.startPayFieldsEnrollmentDeadline(attempt);
    }
    this.loaderIconTD = Promise.resolve(true);
    this.disableSaveButtonForTD = true;
    const autopayCCModel = {
      Amount: 0,
      Autopay: false,
      paymentModeId: paymentModeId,
      AutoCcProcessingDay: 0,
      CreditCardNumber: '0',
      CreditCardType: ECreditCards.Visa,
      NameonCard: '',
      CreditCardExpiryMonth: 275,
      CreditCardExpiryYear: 2099,
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: '0',
      ResponseCode: 0,
      Reason: 'Attempting to Process',
      Key: '',
      PaymentAccountid: 0,
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      OrderId: null,
      FacilityId: this.Currentstore,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Processed,
      TerminalDeviceId: null,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      TenantId: this.TenantId ? this.TenantId : null,
      CCBatchNumber: null
    };
    this.paymentService.saveCCTransaction(Object.assign(autopayCCModel)).subscribe((res: any) => {
      if (payFields) {
        if (!this.isCurrentPayFieldsEnrollment(attempt)) return;
        clearTimeout(this.payFieldsEnrollmentTimer);
        this.isPayFieldsEnrollmentPending = false;
        if (!res || res.Success === false || !(res.Id > 0) || !res.UniqueTransId) {
          this.loaderIconTD = Promise.resolve(false);
          this.failPayFieldsEnrollment('Card setup could not be started. The existing saved card was not changed.');
          return;
        }
      }
      if (res) {
        this.initialCCTOrderId = res.Id;
        this.initialCCTUniqueId = res.UniqueTransId;
        if (this.paymentGateWay == EPaymentGateway.Stripe) {
          if (this.CardWebsiteForm) {
            this.selectedPaymentMode = EPaymentModes.HostedPage;
            this.createSetupCardIntent(res.UniqueTransId)
          } else {
            if (this.terminalDevicesList.length > 1) {
              this.modalRefSelectDevice = this.modalService.show(this.selectStripeDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
              this.loaderIconTD = Promise.resolve(false);
            } else if (this.credentials && this.credentials.DeviceSettings && this.credentials.DeviceSettings.length == 1) {
              this.setUpStripeTerminalAutopay(res.UniqueTransId);
            } else {
              this.toastr.warning('Please ask Administrator to configure Device Setup', 'Device Setup required', this.toasterConfig);
              this.loaderIconTD = Promise.resolve(false);
              const resultResponse = {
                Reason: "Device Setup required!"
              }
              this.saveStripeCCTransaction(resultResponse, this.initialCCTOrderId, EPaymentModes.CreditCard);
            }
          }
        } else if (this.paymentGateWay == EPaymentGateway.OpenEdgeExpress) {
          this.OrderId = res.UniqueTransId;
          this.loaderIconTD = Promise.resolve(false);
          if (paymentModeId == EPaymentModes.CreditCard) {
            this.createRCMALIAS(res.UniqueTransId);
          } else if (this.canUseOpenEdgePayFieldsRuntime()) {
            this.openPayFieldsCardOnFileForm();
          } else {
            this.createCNPALIAS();
          }
        } else {
          if (this.showTDForm) {
            document.getElementById("pay-button").click();
          }
        }
      }
    }, err => {
      if (payFields) {
        if (!this.isCurrentPayFieldsEnrollment(attempt)) return;
        this.loaderIconTD = Promise.resolve(false);
        this.failPayFieldsEnrollment('Card setup could not be started. The existing saved card was not changed.');
        return;
      }
      this.setAutopayStatusObj('Reset');
      this.toastr.error('Failed to Set-Up Autopay', 'Error', this.toasterConfig);
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  disableTDForm() {
    const obj = {
      MandatoryFields: this.mandatoryFieldsTD,
      FName: this.tdFName,
      LName: this.tdLName,
      City: this.tdCity,
      Address: this.tdAddress,
      Zip: this.tdZip,
      Cellphone: this.tdCellphone,
      Email: this.tdEmail,
      NameOnCard: this.tdNameOnCard,
      CellphoneNotValid: this.cellphoneNotValid,
      StateId: this.tdState
    }
    return this.paymentService.disablePaymentTDForm(obj);
  }

  get getUniqueIdentifier() {
    return this.customerDataService.uniqueIdentifier;
  }

  public cellPhoneValidator(control) {
    if ((control.value !== '') && (control.value !== null)) {
      const isWhitespace = (control.value).trim().length < 10;
      const isValid = !isWhitespace;
      this.cellphoneNotValid = isValid ? false : true;
    }
  }

  callOnTokenError() {
    this.tdModalRef.hide();
    this.autopayFailed = true;
    this.setAutopayStatusObj('Failed');
    this.IsmodelShow = false;
    this.disableCancelButton = false;
    this.toastr.error("Failed to Generate Token, Please try again!", 'Failure', this.toasterConfig);
    const obj = {
      message: 'Failed to Generate Token!'
    }
    this.savePreAuthTransaction(obj);
    this.loaderIconTD = Promise.resolve(false);
  }

  setMandatoryFieldHostedPage() {
    this.payFieldsMandatoryFieldsLoaded = false;
    this.payFieldsStateRequired = false;
    this.generalService.GetMandatoryFields(this.Currentstore, this.componentName, this.TDformName)
      .subscribe((response: IGetPermissionMandatoryField) => {
        const data = response;
        this.payFieldsMandatoryFieldsLoaded = Array.isArray(data?.Form?.ListOfProperties);
        if (this.payFieldsMandatoryFieldsLoaded && data.Form.ListOfProperties.length) {
          if (this.paymentGateWay == EPaymentGateway.TdBank) {
            this.fieldsRequired = data.Form.ListOfProperties.some(o => o.Required);
            this.mandatoryFieldsTD = data.Form.ListOfProperties;
          } else {
            this.setOpenEdgeMandatory(response);
          }
        }
      }, () => {
        this.toastr.error('Unable to load mandatory field settings. Please refresh and try again.', 'Settings Error', this.toasterConfig);
      });
  }

  isMandatory(fieldName) {
    let record = this.mandatoryFieldsTD.find((item) => fieldName == item.Name);
    return record.Required;
  }

  onEmailEntered(tdEmail) {
    this.isTDEmailValid = tdEmail.valid;
  }

  UpdateProfileTDBank(paymentAccountId, GatewaycardDetails) {
    let inputModel = null;
    if (this.credentials) {
      this.tdDetails = this.credentials;
    }
    let billingName = (this.tdFName + ' ' + this.tdLName).length > 64 ? (this.tdFName + ' ' + this.tdLName).substring(0, 64) : (this.tdFName + ' ' + this.tdLName);
    let billingAddress = this.tdAddress.length > 64 ? this.tdAddress.substring(0, 64) : this.tdAddress;
    if ((this.isMandatory('tdCountry') && !this.isMandatory('tdState')) || (!this.isMandatory('tdCountry') && this.isMandatory('tdState'))) {
      inputModel = {
        Name: this.tdNameOnCard,
        OneTimeToken: (<HTMLInputElement>document.getElementById('txtTransactionId')).value,
        BillingName: billingName,
        EmailAddress: this.getFirstEmailId(this.tdEmail),
        AddressLine1: billingAddress,
        City: this.tdCity,
        PostalCode: this.tdZip,
        PhoneNumber: this.tdCellphone,
        FacilityId: this.Currentstore,
        PaymentAccountId: paymentAccountId
      }
    } else {
      inputModel = {
        Name: this.tdNameOnCard,
        OneTimeToken: (<HTMLInputElement>document.getElementById('txtTransactionId')).value,
        BillingName: billingName,
        EmailAddress: this.getFirstEmailId(this.tdEmail),
        AddressLine1: billingAddress,
        City: this.tdCity,
        Province: !this.emptyStateList && this.tdState ? this.stateList.find((item) => item.Id == this.tdState).Code : '--',
        Country: this.countryList.find((item) => item.Id == this.tdCountry).IsoCode,
        PostalCode: this.tdZip,
        PhoneNumber: this.tdCellphone,
        FacilityId: this.Currentstore,
        PaymentAccountId: paymentAccountId
      }
    }
    this.generalService.updateProfileTDBank(inputModel).subscribe(res => {
      let cardDetails = JSON.parse((<HTMLInputElement>document.getElementById('customCardDetails')).value);
      var cTypeDetails = JSON.parse((<HTMLInputElement>document.getElementById('cardTypeTD')).value);
      let existingCCNumber = GatewaycardDetails.number ? GatewaycardDetails.number.substr(GatewaycardDetails.number.length - 4) : 0;
      let cType = cTypeDetails.brand;
      cType = cType.replace(/\s/g, '');
      if (cType.toLowerCase() == 'amex') {
        this.cTypeId = ECreditCards.American_Express;
      } else if (cType.toLowerCase() == 'visa') {
        this.cTypeId = ECreditCards.Visa;
      } else if (cType.toLowerCase() == 'mastercard') {
        this.cTypeId = ECreditCards.Master_Card;
      } else if (cType.toLowerCase() == 'discover') {
        this.cTypeId = ECreditCards.Discover;
      } else if (cType.toLowerCase() == 'diners') {
        this.cTypeId = ECreditCards.Diners;
      } else if (cType.toLowerCase() == 'jcb') {
        this.cTypeId = ECreditCards.JCB;
      }
      if (res.Success && cardDetails.last4 != existingCCNumber) {
        let profileResponse = JSON.parse(res.GatewayResponse);
        this.emitAliaseKey = profileResponse.customer_code;
        this.cardNumber = cardDetails ? cardDetails.last4 : 'XXXX';
        this.zipCode = this.tdZip;
        this.Address = this.tdAddress;
        this.nameOnCard = this.tdNameOnCard;
        this.expMonth = cardDetails.expiryMonth ? this.getExpiryMonthValue(parseInt(cardDetails.expiryMonth, 10)) : 275;
        this.expYear = cardDetails.expiryYear ? parseInt(cardDetails.expiryYear, 10) : 2099;

        this.browserLangauge = navigator.language;
        this.userAgent = window.navigator.userAgent;
        var req = new XMLHttpRequest();
        req.open('GET', window.location.href, false);
        req.send(null);
        this.headers = req.getResponseHeader('content-type');
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        this.colorDepth = window.screen.colorDepth;
        this.time_zone = (new Date()).getTimezoneOffset();

        let billingInfoObj = {
          name: this.tdFName + ' ' + this.tdLName,
          address_line1: this.tdAddress,
          city: this.tdCity,
          province: !this.emptyStateList && this.tdState ? this.stateList.find((item) => item.Id == this.tdState).Code : '--',
          country: this.countryList.find((item) => item.Id == this.tdCountry).IsoCode,
          postal_code: this.tdZip,
          phone_number: this.tdCellphone,
          email_address: this.getFirstEmailId(this.tdEmail)
        }

        const threeDSecurePayment = {
          order_number: this.initialCCTOrderId,
          amount: 0.01,
          payment_method: "payment_profile",
          term_url: `${this.baseUrl}/Payments/GetCresReturnToApplication`,
          customer_ip: "::1",
          billing: billingInfoObj,
          payment_profile: {
            customer_code: profileResponse.customer_code,
            complete: false,
            "3d_secure": {
              browser: {
                accept_header: this.headers,
                java_enabled: false,
                language: this.browserLangauge,
                color_depth: this.colorDepth,
                screen_height: this.screenHeight,
                screen_width: this.screenWidth,
                time_zone: this.time_zone,
                user_agent: this.userAgent,
                javascript_enabled: true
              },
              enabled: true,
              version: 2,
              auth_required: true
            }
          }, card_on_file: {
            type: "first_recurring"
          }
        }
        this.generalService.threeDSecurePayment(threeDSecurePayment, this.tdDetails).subscribe(response => {
          // Complete the 0.00$ payment           
          if (response.message == 'Approved') {
            this.cofSeriesIdRes = response;
            this.disableCancelButton = this.UpdateProfile == true ? true : false;
            // this.setAutopayStatusObj(true);
            this.IsmodelShow = false;
            this.tdModalRef.hide();
            this.callCompletionPayment(response, profileResponse.customer_code);
          } else {
            this.tdModalRef.hide();
            this.setAutopayStatusObj('Failed');
            this.IsmodelShow = false;
            this.autopayFailed = true;
            this.autopayFailReason = response.message;
            this.disableCancelButton = false;
            this.savePreAuthTransaction(response);
            this.loaderIconTD = Promise.resolve(false);
          }
        }, err => {
          if (err.status === 302 && err.error.links[0].rel === 'continue') {
            this.IsmodelShow = false;
            this.tdModalRef.hide();
            var formContents = err.error.contents;
            this.callAuthenticationForm(formContents, profileResponse.customer_code);
          } else {
            this.IsmodelShow = false;
            this.setAutopayStatusObj('Failed');
            this.tdModalRef.hide();
            this.autopayFailed = true;
            this.autopayFailReason = err.error.message;
            this.disableCancelButton = false;
            this.savePreAuthTransaction(err.error);
            this.loaderIconTD = Promise.resolve(false);
          }
        });
      } else if (cardDetails.last4 == existingCCNumber) {
        let profileResponse = JSON.parse(res.GatewayResponse);
        if (res.Success) {
          this.setAutopayStatusObj('Success');
          this.process = true;
          this.IsmodelShow = false;
          this.tdModalRef.hide();
          this.emitAliaseKey = profileResponse.customer_code;
          this.cardNumber = cardDetails ? cardDetails.last4 : 'XXXX';
          this.zipCode = this.tdZip;
          this.Address = this.tdAddress;
          this.nameOnCard = this.tdNameOnCard;
          this.expMonth = cardDetails.expiryMonth ? this.getExpiryMonthValue(parseInt(cardDetails.expiryMonth, 10)) : 275;
          this.expYear = cardDetails.expiryYear ? parseInt(cardDetails.expiryYear, 10) : 2099;
          this.disableCancelButton = this.UpdateProfile == true ? true : false;
          this.savePreAuthTransaction(profileResponse);
          this.loaderIconTD = Promise.resolve(false);
        } else {
          this.autopayFailReason = res.Message;
          this.tdModalRef.hide();
          this.setAutopayStatusObj('Failed');
          this.IsmodelShow = false;
          this.autopayFailed = true;
          this.savePreAuthTransaction(profileResponse);
          this.loaderIconTD = Promise.resolve(false);
          this.toastr.error('Failed to update Profile', 'Error', this.toasterConfig);
        }
      } else {
        let profileResponse = JSON.parse(res.GatewayResponse);
        this.autopayFailReason = res.Message;
        this.autopayFailed = true;
        this.tdModalRef.hide();
        this.setAutopayStatusObj('Failed');
        this.IsmodelShow = false;
        this.savePreAuthTransaction(profileResponse);
        this.loaderIconTD = Promise.resolve(false);
        this.toastr.error('Failed to update Profile', 'Error', this.toasterConfig);
      }
    }, errorRes => {
      if (errorRes.error && errorRes.error.message) {
        this.toastr.error(errorRes.error.message, 'Error', this.toasterConfig);
      } else {
        this.toastr.error('Failed to update Profile', 'Error', this.toasterConfig);
      }
      this.tdModalRef.hide();
      this.loaderIconTD = Promise.resolve(false);
      this.autopayFailReason = errorRes.error.message;
      this.autopayFailed = true;
      this.setAutopayStatusObj('Failed');
      this.IsmodelShow = false;
      this.savePreAuthTransaction(errorRes.error);
    });
  }

  callAuthenticationForm(contents, customerCode) {
    this.tdChallengeModalRef = this.modalService.show(this.showTDchallengeForm, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = decodeURIComponent(contents.replace(/\+/g, ' '));
    const formElements = tempDivElement.getElementsByTagName('form');
    var tdBankForm = document.createElement("form");
    tdBankForm.target = "threedframe";
    tdBankForm.method = "Post";
    tdBankForm.action = formElements['challengeform'].action;
    for (var i = 0; i < formElements[0].length; i++) {
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = formElements[0][i]['name'];
      mapInput.setAttribute("value", formElements[0][i]['value']);
      tdBankForm.appendChild(mapInput);
    }
    document.body.appendChild(tdBankForm);
    this.sessiondata = formElements[0][0]['value'];
    sessionStorage.setItem("tdSessiondata", this.sessiondata);
    tdBankForm.submit();
    this.loaderIconTD = Promise.resolve(false);
    if (!this.subTdhost) {
      const source = interval(2000);
      this.subTdhost = source.subscribe(val => this.getCresResponse(val, customerCode));
    }
  }

  getCresResponse(count, customerCode) {
    let res;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    this.paymentService.getCresdata(this.sessiondata).subscribe((Response: any) => {
      if (Response) {
        this.tdChallengeModalRef.hide();
        res = JSON.parse(Response);
        this.loaderIconTD = Promise.resolve(true);
        if (this.subTdhost) {
          this.subTdhost.unsubscribe();
          this.subTdhost = null;
        }
        this.challengeFlowRes(res, customerCode);
      } else if (Response == null) {
        if (count > maxTime) {
          if (this.subTdhost) {
            this.subTdhost.unsubscribe();
            this.subTdhost = null;
            this.autopayFailed = true;
            this.setAutopayStatusObj('Failed');
            this.disableCancelButton = false;
            this.loaderIconTD = Promise.resolve(false);
          }
          const obj = {
            message: 'Time Out'
          }
          this.autopayFailReason = obj.message;
          this.savePreAuthTransaction(obj);
          this.loaderIconTD = Promise.resolve(false);
        }
      }
    }, err => {
      if (count > maxTime) {
        if (this.subTdhost) {
          this.subTdhost.unsubscribe();
          this.subTdhost = null;
          this.autopayFailed = true;
          this.setAutopayStatusObj('Failed');
          this.disableCancelButton = false;
          this.loaderIconTD = Promise.resolve(false);
        }
        const obj = {
          message: 'Time Out'
        }
        this.autopayFailReason = obj.message;
        this.savePreAuthTransaction(obj);
        this.loaderIconTD = Promise.resolve(false);
      }
    });
  }

  challengeFlowRes(tdCres, customerCode) {
    if (this.credentials) {
      this.tdDetails = this.credentials;
    }
    const inputModel = {
      payment_method: "payment_profile",
      card_response: {
        cres: tdCres.cres
      }
    }
    this.generalService.tDBankPaymentContinue(inputModel, this.sessiondata, this.credentials).subscribe((response: any) => {
      var tdCountinueResponse;
      if (response) {
        this.cofSeriesIdRes = response;
        this.sessiondata = null;
        tdCountinueResponse = response;
      }
      if (tdCountinueResponse.message == "Approved") {
        this.disableCancelButton = this.UpdateProfile == true ? true : false;
        this.IsmodelShow = false;
        this.callCompletionPayment(tdCountinueResponse, customerCode);
      } else {
        this.disableCancelButton = false;
        this.autopayFailed = true;
        this.setAutopayStatusObj('Failed');
        this.autopayFailReason = tdCountinueResponse.message;
        this.savePreAuthTransaction(response);
        this.loaderIconTD = Promise.resolve(false);
      }
    }, err => {
      this.setAutopayStatusObj('Failed');
      this.disableCancelButton = false;
      this.autopayFailed = true;
      this.autopayFailReason = err.error.message;
      this.savePreAuthTransaction(err.error);
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  callCompletionPayment(transactionRes, customerCode) {
    const input = {
      transactionId: transactionRes.id,
      completion: {
        order_number: this.initialCCTOrderId,
        amount: 0.00,
        payment_method: "payment_profile",
        payment_profile: {
          complete: true,
          customer_code: customerCode,
          card_id: 1,
          "3d_secure": {
            browser: {
              accept_header: this.headers,
              java_enabled: false,
              language: this.browserLangauge,
              color_depth: this.colorDepth,
              screen_height: this.screenHeight,
              screen_width: this.screenWidth,
              time_zone: this.time_zone,
              user_agent: this.userAgent,
              javascript_enabled: true
            },
            enabled: true,
            version: 2,
            auth_required: true
          }
        }
      }
    }
    this.generalService.completePreAuthPayment(input, this.tdDetails).subscribe(res => {
      if (res.message == "Approved") {
        this.disableCancelButton = this.UpdateProfile == true ? true : false;
        this.process = true;
        this.setAutopayStatusObj('Success');
        this.savePreAuthTransaction(transactionRes);
        this.loaderIconTD = Promise.resolve(false);
      } else {
        this.autopayFailed = true;
        this.disableCancelButton = false;
        this.setAutopayStatusObj('Failed');
        this.autopayFailReason = res.message;
        this.savePreAuthTransaction(res);
        this.loaderIconTD = Promise.resolve(false);
      }
    }, err => {
      this.autopayFailed = true;
      this.disableCancelButton = false;
      this.setAutopayStatusObj('Failed');
      this.autopayFailReason = err.error.message;
      this.savePreAuthTransaction(err.error);
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  onTransactionCancel() {
    this.tdChallengeModalRef.hide();
    this.loaderIcon = Promise.resolve(false);
    if (this.subTdhost) {
      this.subTdhost.unsubscribe();
      this.subTdhost = null;
    }
  }

  deleteTdProfile(facilityId, customerCode) {
    this.paymentService.deleteTDBankProfile(facilityId, customerCode).subscribe((res) => {
      if (res.Success) {
        this.cofSeriesIdRes = null;
        this.emitAliaseKey = null;
        //while Updating Auto CC
        if (this.AutopayProfileUpdate && this.UniqueIdentifier == this.AutopayProfileUpdate.PaymentAccountId) {
          this.toastr.warning('Auto CC is Removed', 'Alert', this.toasterConfig);
          this.loaderIconTD = Promise.resolve(false);
        } else {
          //while Creating Autocc
          this.toastr.warning('Failed to Set Up Auto CC', 'Alert', this.toasterConfig);
          this.loaderIconTD = Promise.resolve(false);
        }
      } else {
        this.cofSeriesIdRes = null;
        this.toastr.error('Failed to Delete Auto CC', 'Error', this.toasterConfig);
        this.loaderIconTD = Promise.resolve(false);
      }
    }, err => {
      this.cofSeriesIdRes = null;
      this.toastr.error('Failed to Delete Auto CC', 'Error', this.toasterConfig);
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  savePreAuthTransaction(preAuthResponse) {
    var saveCCT = {
      Amount: 0,
      Autopay: false,
      PaymentModeId: 9,
      AutoCcProcessingDay: 0,
      CreditCardNumber: this.cardNumber ? this.cardNumber : 'XXXX',
      CreditCardType: this.cTypeId,
      CreditCardExpiryMonth: this.expMonth ? this.expMonth : 275,
      CreditCardExpiryYear: this.expYear ? this.expYear : 2099,
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: (preAuthResponse && preAuthResponse.id) ? preAuthResponse.id : (preAuthResponse && preAuthResponse.validation && preAuthResponse.validation.id) ? preAuthResponse.validation.id : '0',
      Reason: preAuthResponse && preAuthResponse.message ? preAuthResponse.message : " ",
      ResponseCode: (preAuthResponse && preAuthResponse.message_id) ? preAuthResponse.message_id : (preAuthResponse && preAuthResponse.code) ? preAuthResponse.code : '',
      Key: preAuthResponse && preAuthResponse.card_on_file ? preAuthResponse.card_on_file.series_id : '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      UniqueTransId: null,
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      OrderId: this.initialCCTOrderId,
      FacilityId: this.Currentstore,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Processed,
      PaymentAccountNo: this.emitAliaseKey ? this.emitAliaseKey : null,
      TenantId: this.TenantId ? this.TenantId : null,
      PaymentAccountid: this.emitAliaseKey ? this.emitAliaseKey : null,
      CreditCardBillingAddress: this.tdAddress.length > 50 ? this.tdAddress.substring(0, 50) : this.tdAddress,
      CreditCardBillingZip: this.tdZip,
      NameonCard: this.tdNameOnCard,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      GatewayDetails: this.paymentService.requestGatewaydetails(this.credentials, this.paymentGateWay, '')
    };
    this.paymentService.saveCCTransaction(saveCCT).subscribe((response: any) => {
      if (response) {
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.autopayFailed = true;
      this.disableCancelButton = false;
      this.setAutopayStatusObj('Failed');
      this.autopayFailReason = 'Declined';
      this.loaderIcon = Promise.resolve(false);
    });
  }

  setUserPermissions() {
    const userPermissionsAutoCCDay = this.generalService.getUserPermissionsForModule(EUserFunctions['Rental : Auto CC Processing Day']);
    this.editRightAutoCCProcessDay = userPermissionsAutoCCDay.EditRight;
    this.viewRightAutoCCProcessDay = userPermissionsAutoCCDay.ViewRight;
  }

  mapCountryIsoCode(): void {
    if (this.countryList && this.countryList.length) {
      this.commonMethod.mapCountryIsoCode(this.countryList);
    }
  }

  setOpenEdgeMandatory(response) {
    this.openEdgeBillingFields = '';
    this.payFieldsStateRequired = response.Form.ListOfProperties.some(field => field.Name == 'tdState' && field.Required);
    this.payFieldsMandatoryFieldsLoaded = true;
    response.Form.ListOfProperties.forEach(field => {
      var mandatoryField = '';
      if (field.Name == 'tdFName') {
        if (field.Required) {
          mandatoryField = `<BILLINGFIRSTNAME> <REQUIRED>TRUE</REQUIRED> </BILLINGFIRSTNAME>`;
        } else {
          mandatoryField = `<BILLINGFIRSTNAME> <REQUIRED>FALSE</REQUIRED> </BILLINGFIRSTNAME>`;
        }
      } else if (field.Name == 'tdLName') {
        if (field.Required) {
          mandatoryField = `<BILLINGLASTNAME> <REQUIRED>TRUE</REQUIRED> </BILLINGLASTNAME>`;
        } else {
          mandatoryField = `<BILLINGLASTNAME> <REQUIRED>FALSE</REQUIRED> </BILLINGLASTNAME>`;
        }
      } else if (field.Name == 'tdAddress') {
        if (field.Required) {
          mandatoryField = `<BILLINGADDRESSONE> <REQUIRED>TRUE</REQUIRED> </BILLINGADDRESSONE>`;
        } else {
          mandatoryField = `<BILLINGADDRESSONE> <REQUIRED>FALSE</REQUIRED> </BILLINGADDRESSONE>`;
        }
      } else if (field.Name == 'tdZip') {
        if (field.Required) {
          mandatoryField = `<BILLINGPOSTALCODE> <REQUIRED>TRUE</REQUIRED> </BILLINGPOSTALCODE>`;
        } else {
          mandatoryField = `<BILLINGPOSTALCODE> <REQUIRED>FALSE</REQUIRED> </BILLINGPOSTALCODE>`;
        }
      } else if (field.Name == 'tdState') {
        if (field.Required) {
          mandatoryField = `<BILLINGSTATEORPROVINCE> <REQUIRED>TRUE</REQUIRED> </BILLINGSTATEORPROVINCE>`;
        } else {
          mandatoryField = `<BILLINGSTATEORPROVINCE> <REQUIRED>FALSE</REQUIRED> </BILLINGSTATEORPROVINCE>`;
        }
      } else if (field.Name == 'tdCity') {
        if (field.Required) {
          mandatoryField = `<BILLINGCITY> <REQUIRED>TRUE</REQUIRED> </BILLINGCITY>`;
        } else {
          mandatoryField = `<BILLINGCITY> <REQUIRED>FALSE</REQUIRED> </BILLINGCITY>`;
        }
      } else if (field.Name == 'tdCountry') {
        if (field.Required) {
          mandatoryField = `<BILLINGCOUNTRYCODE> <REQUIRED>TRUE</REQUIRED> </BILLINGCOUNTRYCODE>`;
        } else {
          mandatoryField = `<BILLINGCOUNTRYCODE> <REQUIRED>FALSE</REQUIRED> </BILLINGCOUNTRYCODE>`;
        }
      } else if (field.Name == 'CustomerTitle') {
        if (field.Required) {
          mandatoryField = `<BILLINGCUSTOMERTITLE> <REQUIRED>TRUE</REQUIRED> </BILLINGCUSTOMERTITLE>`;
        } else {
          mandatoryField = `<BILLINGCUSTOMERTITLE> <REQUIRED>FALSE</REQUIRED> </BILLINGCUSTOMERTITLE>`;
        }
      } else if (field.Name == 'MiddleName') {
        if (field.Required) {
          mandatoryField = `<BILLINGMIDDLENAME> <REQUIRED>TRUE</REQUIRED> </BILLINGMIDDLENAME>`;
        } else {
          mandatoryField = `<BILLINGMIDDLENAME> <REQUIRED>FALSE</REQUIRED> </BILLINGMIDDLENAME>`;
        }
      } else if (field.Name == 'CompanyName') {
        if (field.Required) {
          mandatoryField = `<BILLINGCOMPANY> <REQUIRED>TRUE</REQUIRED> </BILLINGCOMPANY>`;
        } else {
          mandatoryField = `<BILLINGCOMPANY> <REQUIRED>FALSE</REQUIRED> </BILLINGCOMPANY>`;
        }
      } else if (field.Name == 'AddressTwo') {
        if (field.Required) {
          mandatoryField = `<BILLINGADDRESSTWO> <REQUIRED>TRUE</REQUIRED> </BILLINGADDRESSTWO>`;
        } else {
          mandatoryField = `<BILLINGADDRESSTWO> <REQUIRED>FALSE</REQUIRED> </BILLINGADDRESSTWO>`;
        }
      }
      if (this.openEdgeBillingFields && mandatoryField) {
        this.openEdgeBillingFields = this.openEdgeBillingFields + mandatoryField;
      } else if (mandatoryField) {
        this.openEdgeBillingFields = mandatoryField;
      }
    });
   this.openEdgeBillingFields +=`<SUBMITBUTTON><LABEL>${this.CCPlaceHolder}</LABEL><VISIBLE>TRUE</VISIBLE></SUBMITBUTTON>`;
  }

  onClickAutoPopulateBillingInfo(gateway) {
    if (gateway == EPaymentGateway.TdBank) {
      if (this.isAutoPopulateBillingInfo && this.customerInfo) {
        this.tdAddress = this.customerInfo.AddressOne ? this.customerInfo.AddressOne : this.tenantModel && this.tenantModel.Address ? this.tenantModel.Address : "";
        this.tdZip = this.customerInfo.PostalCode ? this.customerInfo.PostalCode : this.tenantModel && this.tenantModel.Zip ? this.tenantModel.Zip : "";
        this.tdFName = this.customerInfo.FirstName;
        this.tdLName = this.customerInfo.LastName;
        this.tdEmail = this.customerInfo.Email;
        this.tdCity = this.customerInfo.City ? this.customerInfo.City : this.tenantModel && this.tenantModel.City ? this.tenantModel.City : "";
        this.tdState = this.customerInfo.StateId ? this.customerInfo.StateId : this.tenantModel && this.tenantModel.State.Id ? this.tenantModel.State.Id : 0;
        this.tdCountry = this.customerInfo.CountryId;
        this.tdCellphone = this.customerInfo.CellPhoneNumber;
        //this.onCountryChange(this.tdCountry, 1);
      } else {
        this.tdAddress = '';
        this.tdZip = '';
        this.tdFName = '';
        this.tdLName = '';
        this.tdEmail = '';
        this.tdCity = '';
        this.tdState = 0;
        this.tdCountry = environment.defaultCountryId;
        this.tdCellphone = '';
        this.onCountryChange(this.tdCountry, 1)
      }
    } else if (gateway == EACHPaymentGateway.EdgeExpress) {
      if (this.isAutoPopulateBillingInfo && this.customerInfo) {
        this.achAddress = this.customerInfo.AddressOne ? this.customerInfo.AddressOne : this.tenantModel && this.tenantModel.Address ? this.tenantModel.Address : "";
        this.achFirstName = this.customerInfo.FirstName;
        this.achLastName = this.customerInfo.LastName;
        this.achCity = this.customerInfo.City ? this.customerInfo.City : this.tenantModel && this.tenantModel.City ? this.tenantModel.City : "";
        this.achState = this.customerInfo.StateId ? this.customerInfo.StateId : this.tenantModel && this.tenantModel.State.Id ? this.tenantModel.State.Id : 0;
        this.achCountry = this.customerInfo.CountryId;
        this.onCountryChange(this.achCountry, 1);
      } else {
        this.achFirstName = '';
        this.achLastName = '';
        this.achAddress = '';
        this.achCity = '';
        this.achState = 0;
        this.achCountry = environment.defaultCountryId;
        this.onCountryChange(this.achCountry, 1);
      }
    } else {
      this.createCNPALIAS();
    }
  }

  setCNPCustomerInfo() {
    this.customerInfo.AddressOne = this.customerInfo.AddressOne && this.customerInfo.AddressOne.length > 50 ?
      this.customerInfo.AddressOne.substring(0, 50) : (this.tenantModel && this.tenantModel.Address ? this.tenantModel.Address : this.customerInfo.AddressOne);
    this.customerInfo.City = this.customerInfo.City ? this.customerInfo.City : this.tenantModel && this.tenantModel.City ? this.tenantModel.City : "";
    this.customerInfo.PostalCode = this.customerInfo.PostalCode ? this.customerInfo.PostalCode : this.tenantModel && this.tenantModel.Zip ? this.tenantModel.Zip : "";
    const customerInfo = this.paymentService.mapBillingInfo(this.customerInfo);
    this.requestParam = "<REQUEST>" +
      "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
      "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
      "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
      "<TRANSACTIONTYPE>CREDITAUTH</TRANSACTIONTYPE>" +
      "<AMOUNT>0</AMOUNT>" +
      "<BILLINGFIRSTNAME>" + customerInfo.firstName + "</BILLINGFIRSTNAME>" +
      "<BILLINGMIDDLENAME>" + customerInfo.middleName + "</BILLINGMIDDLENAME>" +
      "<BILLINGLASTNAME>" + customerInfo.lastName + "</BILLINGLASTNAME>" +
      "<BILLINGADDRESS1>" + customerInfo.address + "</BILLINGADDRESS1>" +
      "<BILLINGCOMPANY>" + customerInfo.companyName + "</BILLINGCOMPANY>" +
      "<BILLINGCITY>" + customerInfo.city + "</BILLINGCITY>" +
      "<BILLINGCOUNTRY>" + customerInfo.countryCode + "</BILLINGCOUNTRY>" +
      "<BILLINGSTATE>" + customerInfo.stateCode + "</BILLINGSTATE>" +
      "<BILLINGPOSTALCODE>" + customerInfo.postalCode + "</BILLINGPOSTALCODE>" +
      "<ORDERID>" + this.OrderId + "</ORDERID>" +
      "<CREATEALIAS>TRUE</CREATEALIAS>" +
      "<HOSTPAYSETTING>" +
      "<CARDBRAND>" + this.facilityCreditCards + "</CARDBRAND>" +
      "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
      "<CUSTOMIZATION>" +
      "<PAGE> " +
      this.openEdgeBillingFields +
      "</PAGE>" +
      "<BRANDING>" +
      "<BODY>" +
      "<FONT-FAMILY> LATO,SANS-SERIF;</FONT-FAMILY>" +
      "<FONT-SIZE>14px</FONT-SIZE>" +
      "</BODY>" +
      "<BTN>" +
      "<BACKGROUND-COLOR>#3757C5;</BACKGROUND-COLOR>" +
      "<FONT-SIZE>14PX;</FONT-SIZE>" +
      "</BTN>" +
      "<SPECIALCSS>" +
      "<SECTION-HEADER-FONT-SIZE>18px</SECTION-HEADER-FONT-SIZE>" +
      "<COLOR>#3757C5;</COLOR>" +
      "</SPECIALCSS>" +
      "</BRANDING>" +
      "</CUSTOMIZATION>" +
      "<POSDEVICE>" +
      "<TYPE>KEYED</TYPE>" +
      "</POSDEVICE>" +
      "</HOSTPAYSETTING>" +
      "</REQUEST>";
  }

  getTenantDetailsById(tenantId) {
    this.prospectSerice.getContactInfo(tenantId).subscribe((response: any) => {
      if (response) {
        this.customerInfoPresent = true;
        this.customerInfo = {
          FirstName: response.FirstName,
          MiddleName: response.MiddleName,
          LastName: response.LastName,
          CompanyName: '',
          AddressOne: response.Address,
          City: response.City,
          CountryCode: response.CountryCode.substring(0, 2),
          StateCode: response.State && response.State.Code ? response.State.Code : '',
          StateId: response.State && response.State.Id ? response.State.Id : '',
          PostalCode: response.Zip,
          CountryId: response.CountryId,
          CellPhoneNumber: response.CellPhoneNumber,
          Email: response.Email,
          FullName: response.BusinessAccount && response.CompanyName ? response.CompanyName : `${response.FirstName}${response.MiddleName ? ' ' + response.MiddleName : ''} ${response.LastName}`.trim()
        }
      }
    })
  }

  restrictAddressinput(event) {
    if (event.charCode == 60 || event.charCode == 62 || event.charCode == 47) {
      event.preventDefault();
    }
  }

  createACHAlias() {
    this.achModalRef.hide();
    this.IsmodelShow = false;
    let routingNo = this.autoAchForm.get('RoutingNumber').value;
    let accNo = this.autoAchForm.get('AccountNumber').value;
    let nameOnAccount = this.autoAchForm.get('NameOnAccount').value;
    if (this.achSettingPaymentGateway) {
      this.loaderIcon = Promise.resolve(true);
      let countyCode = this.achCountry == 2 ? 124 : 840; //124 : canada, 840 : US
      var aliaseRequest = "<REQUEST>" +
        "<XWEBID>" + this.achSettingPaymentGateway.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.achSettingPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.achSettingPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CHECKALIASCREATE</TRANSACTIONTYPE>" +
        "<ACCOUNTNUMBER>" + accNo + "</ACCOUNTNUMBER>" +
        "<ROUTINGNUMBER>" + routingNo + "</ROUTINGNUMBER>" +
        "<NAMEONACCOUNT>" + nameOnAccount + "</NAMEONACCOUNT>" +
        "<CREATECHECKALIAS>TRUE</CREATECHECKALIAS>" +
        "<BILLINGFIRSTNAME>" + this.achFirstName + "</BILLINGFIRSTNAME>" +
        "<BILLINGLASTNAME>" + this.achLastName + "</BILLINGLASTNAME>" +
        "<BILLINGADDRESSONE>" + this.achAddress + "</BILLINGADDRESSONE>" +
        "<BILLINGSTATEORPROVINCE>" + this.achState + "</BILLINGSTATEORPROVINCE>" +
        "<BILLINGCOUNTRYCODE>" + countyCode + "</BILLINGCOUNTRYCODE>" +
        "</REQUEST>";
      this.paymentService.getCNPService(this.achSettingPaymentGateway.QueryPaymentStatusURL, aliaseRequest).subscribe((res: any) => {
        if (res) {
          this.loaderIcon = Promise.resolve(false);
          const jsonResp = JSON.parse(res);
          this.ACHaccounttype = this.autoAchForm.get('ACHAccounttype').value;
          if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Alias_Success && jsonResp.RESULT.RESPONSEDESCRIPTION == "Alias Success: Created") {
            this.toastr.success(`Alias created Successfully`, 'Success', this.toasterConfig);
            this.setAutopayStatusObj('Success');
            this.process = true;
            this.autopayFailed = false;
            this.emitAliaseKey = jsonResp.RESULT.ALIAS;
            this.ACHRoutingNo = jsonResp.RESULT.ROUTINGNUMBER;
            this.ACHaccountno = jsonResp.RESULT.ACCOUNT;
            this.Accountname = nameOnAccount;
            this.ACHaccountclass = 276;
            this.loaderIcon = Promise.resolve(true);
          } else {
            this.setAutopayStatusObj('Failed');
            this.toastr.error('Failed to create Alias', 'Error', this.toasterConfig);
            this.autopayFailed = true;
            this.autopayFailReason = jsonResp.RESULT.RESPONSEDESCRIPTION;
            this.loaderIcon = Promise.resolve(false);
            jsonResp.RESULT['ROUTINGNUMBER'] = jsonResp.RESULT['ACCOUNT'] = '';
          }
          this.saveAchTransactions(jsonResp.RESULT, this.autopayFailed ? EPaymentTransactionType.Declined : EPaymentTransactionType.Processed, jsonResp.RESULT.RESPONSEDESCRIPTION, EPaymentModes.ACH);
        }
      }, err => {
        this.achModalRef.hide();
        this.autopayFailed = true;
        this.setAutopayStatusObj('Failed');
        this.toastr.error('Failed to create ACH Alias', 'Error', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.saveAchTransactions(null, this.autopayFailed ? EPaymentTransactionType.Declined : EPaymentTransactionType.Processed, 'Declined!', EPaymentModes.ACH);
      }
      );
    } else {
      this.setAutopayStatusObj('Reset');
      this.autopayFailed = true;
      this.toastr.warning('Please ask Administrator to configure Facility ACH Settings', 'Settings required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  disableAchForm() {
    if (this.autoAchForm.get('RoutingNumber').value && this.autoAchForm.get('AccountNumber').value && this.autoAchForm.get('NameOnAccount').value && this.achFirstName && this.achLastName && this.achAddress && this.achCity && this.achState && this.achCountry) {
      return false;
    } else {
      return true;
    }
  }

  getFirstEmailId(tdEmail) {
    let emailIdList = '';
    if (tdEmail && tdEmail.length) {
      emailIdList = tdEmail.split(/[,;]/);
    }
  }

  isUnitSelected() {
    if (this.paymentOrigin !== EPaymentOrigin.Rental && this.paymentOrigin !== EPaymentOrigin.Transfer) {
      if (this.isModifyRental && this.autopayInfoForUnit?.Mode) {
        return true;
      } else if (this.autoPayHistory.length && this.selectedUnitLease && this.autopayInfoForUnit?.Mode) {
        return true;
      }
      return false;
    }
    return false;
  }

  onUnitChange(val, afterDelete) {
    if (this.payFieldsEnrollmentContext) {
      this.closePayFieldsCardOnFileForm();
      this.payFieldsPreviousCard = null;
    }
    if (val || val == 0) {
      if (val == 0) {
        this.autopayInfoForUnit = null;
        this.autopayHistoryForUnit = this.autoPayHistory.reduce((acc, unit) => {
          if (unit.AutoPayHistory) {
            return acc.concat(unit.AutoPayHistory);
          }
          return acc;
        }, [])
        if (!this.isModifyRental || afterDelete) {
          this.checkautoPay = false;
          this.autoCCDays = 0;
          this.email = false;
          this.printAutopay = false;
          this.modeSelect = '0';
        }
      } else {
        this.resetautopay();
        this.isUnitChanged = true;
        this.autopayInfoForUnit = this.autoPayHistory.find((ele) => ele.LeaseNo == val);
        this.autopayHistoryForUnit = this.autopayInfoForUnit?.AutoPayHistory;
        if (!this.isModifyRental || afterDelete) {
          this.checkautoPay = this.autopayInfoForUnit?.IsAutoPay;
          this.autoCCDays = this.autopayInfoForUnit?.ProcessingDay;
          this.email = this.autopayInfoForUnit?.EmailPaymentReceipt;
          this.printAutopay = this.autopayInfoForUnit?.PrintPaymentReceipt;
          this.modeSelect = !this.autopayInfoForUnit?.Mode ? '0' : this.autopayInfoForUnit?.Mode == 'CC' ? 'CardWebsite' :
            this.autopayInfoForUnit?.Mode;
        }
      }
    }
    this.setInitialAutopayData();
    this.sendSaveResponseToModifyRental(false, afterDelete);
    this.GetAutoPayDetails(val,this.Currentstore)
  }

  GetAutoPayHistoryDetails(tenantId, facilityId, afterDelete) {
    this.customerService.GetAutoPayHistoryDetails(tenantId, facilityId).subscribe((response: IAutoPayInfo[]) => {
      this.autoPayHistory = response;
      this.loaderIconAuto = Promise.resolve(false);
      if (this.autoPayHistory.length) {
        this.autoPayHistory.map((ele) => {
          ele['CardTypeName'] = this.commonMethod.getCardTypeName(ele.CardType);
          if (ele.IsMovedOut) {
            ele.UnitNo = ele.UnitNo + '' + '(Moved Out)';
          }
          ele.AutoPayHistory?.map((item) => {
            item.TransactionDate = item.TransactionDate?.replace('Z', '');
            item['FormattedTransactionDate'] = this.datepipe.transform(item.TransactionDate, 'MM/dd/yyyy hh:mm:ss a');
            item['TransactionTypeValue'] = this.commonMethod.getPaymentTransactionTypeName(item.TransactionType);
            item['PaymentModeName'] = this.commonMethod.getPaymentModeName(item.PaymentMode);
          })
        });
      }
      if (this.isModifyRental && this.currentLeaseNo) {
        this.selectedUnitLease = 0;
        setTimeout(() => {
          this.selectedUnitLease = this.currentLeaseNo;
        }, 50);
        this.onUnitChange(this.currentLeaseNo, afterDelete);
      } else {
        if (this.autoPayHistory.length == 1) {
          this.selectedUnitLease = this.autoPayHistory[0].LeaseNo;
        } else {
          if (!afterDelete) {
            this.selectedUnitLease = 0;
          }
        }
        this.onUnitChange(this.selectedUnitLease, afterDelete);
      }
    }, err => {
      this.loaderIconAuto = Promise.resolve(false);
    });
  }

  exportAutopayHistory() {
    let csvData = 'Transaction Date, Transaction Type, Order Id, Payment Mode, Amount, Card Number, Auth Code, Batch Number, Response Code, Status\n';
    this.autopayHistoryForUnit.forEach((item) => {
      item.AuthCode = item.AuthCode ? item.AuthCode : '';
      item.BatchNumber = item.BatchNumber ? item.BatchNumber : '';
      item.AmountVal = item.Amount;
      item.AmountVal = item.AmountVal ? this.currencyPipe.transform(item.AmountVal, 'USD', 'symbol', '1.2-2').replace(/,/g, '') : '$0.00';
      const row = `${item.FormattedTransactionDate},${item.TransactionTypeValue},${item.OrderId},${item.PaymentModeName},${item.AmountVal},${item.CardNumber},${item.AuthCode},${item.BatchNumber},${item.ResponseCode},${item.Status}\n`;
      csvData += row;
    });
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    let unitNo = this.selectedUnitLease ? this.autopayInfoForUnit?.UnitNo : 'All';
    link.download = 'autopayHistory' + '_' + unitNo + '_' + '.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  printAutopayHistory() {
    this.loaderIconAuto = Promise.resolve(true);
    let inputModel = [];
    this.autopayHistoryForUnit.forEach((ele) => {
      let obj = {
        TransactionDate: ele.FormattedTransactionDate,
        TransactionType: ele.TransactionTypeValue,
        OrderId: ele.OrderId,
        PaymentMode: ele.PaymentModeName,
        Amount: ele.Amount,
        CardNumber: ele.CardNumber,
        AuthCode: ele.AuthCode,
        BatchNumber: ele.BatchNumber,
        ResponseCode: ele.ResponseCode,
        Status: ele.Status,
      }
      inputModel.push(obj);
    })
    this.customerService.ConvertAutopayHistoryToPDF(inputModel).subscribe(response => {
      this.loaderIconAuto = Promise.resolve(false);
      const url = URL.createObjectURL(response);
      this.printReceipt.show();
      const iframe = this.myIframeAutopayHistory.nativeElement;
      iframe.src = url;
      iframe.style.height = '500px';
      iframe.style.width = '100%';
    }, err => {
      this.loaderIconAuto = Promise.resolve(false);
    });
  }

  disableFieldsForHistory() {
    if (this.autopayInfoForUnit && this.autopayInfoForUnit.IsMovedOut && this.paymentOrigin == EPaymentOrigin.ReInstate && this.currentLeaseNo == this.selectedUnitLease) {
      return false;
    }
    if (this.paymentOrigin !== EPaymentOrigin.Rental && this.paymentOrigin !== EPaymentOrigin.Transfer) {
      if (this.selectedUnitLease == 0 || (this.autopayInfoForUnit && this.autopayInfoForUnit.IsMovedOut) || (this.isModifyRental && this.currentLeaseNo !== +this.selectedUnitLease)) {
        return true;
      }
      return false;
    }
    return false;
  }

  deleteAutopay() {
    this.modalDeleteAutopay.hide();
    this.loaderIconAuto = Promise.resolve(true);
    let deleteInput = {
      IsAutoPay: this.autopayInfoForUnit.IsAutoPay,
      IsCc: this.autopayInfoForUnit.Mode == 'CC' ? true : false,
      IsAch: this.autopayInfoForUnit.Mode == 'ACH' ? true : false,
      IsEft: this.autopayInfoForUnit.Mode == 'EFT' ? true : false,
      TransactionTypeId: this.autopayInfoForUnit.TransactionType,
      LeaseNo: this.autopayInfoForUnit.LeaseNo,
      FacilityId: this.Currentstore,
      TenantId: this.TenantId,
      PaymentGateway: this.paymentGateWay
    }
    this.customerService.DeletePaymentSetUp(deleteInput).subscribe(response => {
      if (response && response.Success) {
        this.resetAutopayDetails();
        this.emitResponse(true);
        const autopayCloseBtn = document.getElementById('autopayClose-button');
        if (autopayCloseBtn) {
          autopayCloseBtn.click();
        }
        this.toastr.success('Autopay deleted successfully for Unit: ' + this.autopayInfoForUnit.UnitNo, 'Success', this.toasterConfig);
        this.GetAutoPayHistoryDetails(this.TenantId, this.Currentstore, true);
        this.GetAutoPayDetails(this.leaseNo, this.Currentstore);
      } else {
        this.toastr.error(`Failed to delete Autopay for the selected Unit`, 'Failure', this.toasterConfig);
        this.loaderIconAuto = Promise.resolve(false);
      }
    }, err => {
      this.toastr.error(`Failed to delete Autopay for the selected Unit`, 'Failure', this.toasterConfig);
      this.loaderIconAuto = Promise.resolve(false);
    });
  }

  disableModeOption(val) {
    if (val == 1 && this.paymentGateWay == EPaymentGateway.TdBank) {
      return true;
    } else {
      let notRentalOrTransfer = this.paymentOrigin !== EPaymentOrigin.Rental && this.paymentOrigin !== EPaymentOrigin.Transfer;
      if (val == 1 && (notRentalOrTransfer && (this.autopayInfoForUnit?.Mode == 'ACH' || this.autopayInfoForUnit?.Mode == 'EFT'))) {
        return true;
      } else if (val == 2 && (notRentalOrTransfer && (this.autopayInfoForUnit?.Mode == 'ACH' || this.autopayInfoForUnit?.Mode == 'EFT'))) {
        return true;
      } else if (val == 3 && (notRentalOrTransfer && (this.autopayInfoForUnit?.Mode == 'CC' || this.autopayInfoForUnit?.Mode == 'EFT') ||
        (this.paymentGateWay === EPaymentGateway.Stripe && this.countryId == ECountries.Canada) || !this.isEnableAch)) {
        return true;
      } else if (val == 4 && (notRentalOrTransfer && (this.autopayInfoForUnit?.Mode == 'CC' || this.autopayInfoForUnit?.Mode == 'ACH') ||
        (this.paymentGateWay !== EPaymentGateway.Stripe && !this.IsEnableEFT) ||
        (this.paymentGateWay === EPaymentGateway.Stripe && this.countryId == ECountries.UnitedStatesOfAmerica))) {
        return true;
      }
    }
    return false;
  }

  saveAutoPayData(ccObj) {
    this.loaderIconAuto = Promise.resolve(true);
    ccObj.LeaseNo = this.autopayInfoForUnit.LeaseNo;
    this.paymentService.saveautopay(ccObj).subscribe((response: ISaveModel) => {
      if (response.Success) {
        this.setAutopayStatusObj('Reset');
        this.sendSaveResponseToModifyRental(true, false);
        this.disableCancelButton = false;
        this.setInitialAutopayData();
        this.loaderIconAuto = Promise.resolve(false);
        const linkedUnits = [
          ...(this.enableLinkedUnitLeaseNo.length > 0 ? this.autopayLinledUnitList.map(ele => ele.UnitNumber) : []),
          this.autopayInfoForUnit.UnitNo
        ];
        this.toastr.success('Autopay Updated Successfully for the following Units : ' + linkedUnits, 'Success', this.toasterConfig);
        this.GetAutoPayHistoryDetails(this.TenantId, this.Currentstore, false);
        this.GetAutoPayDetails(this.leaseNo, this.Currentstore);
      } else {
        this.loaderIconAuto = Promise.resolve(false);
      }
    }, err => {
      this.loaderIconAuto = Promise.resolve(false);
    });
  }

  sendSaveResponseToModifyRental(onSave, afterDelete) {
    let obj = {
      modeSelect: this.modeSelect,
      checkAutopay: this.checkautoPay,
      isNewlySaved: onSave,
      afterDelete: afterDelete,
      LinkedleaseNo : this.enableLinkedUnitLeaseNo
    }
    if (this.isModifyRental) {
      this.responseData.emit(obj);
      this.facOpsDataService.autoPayData = null;
    }
  }

  callLinkedUnlitList() {
    this.paymentService.callLinkedAutopayList(this.Currentstore, this.TenantId, this.leaseNo).subscribe((res: any) => {
      if (res) {
        this.autopayLinledUnitList = res;
      }
    })
  }

  showHistorySection(type) {
    if (this.paymentOrigin == EPaymentOrigin.Rental || this.paymentOrigin == EPaymentOrigin.Transfer) {
      return false;
    } else if (type == 'delete' && this.isModifyRental && this.currentLeaseNo !== +this.selectedUnitLease) {
      return false;
    }
    return true;
  }

  disablePrintExport() {
    if (!this.autopayHistoryForUnit || !this.autopayHistoryForUnit.length) {
      return true;
    }
    return false;
  }

  disableAutopayDelete() {
    if (this.disableFieldsForHistory() || !this.autopayInfoForUnit || !this.autopayInfoForUnit?.Mode) {
      return true;
    }
    return false;
  }

  GetAutoPayDetails(leaseNo, facilityId) {
    this.customerService.GetAutoPayDetails(leaseNo, facilityId).subscribe((response: any) => {
      if (response) {
        this.tenantAutoPayDetails = response;
        this.tenantAutoPayDetails['FacilityId'] = facilityId;
        this.tenantAutoPayDetails['LeaseNo'] = leaseNo;
        this.tenantAutoPayDetails['LinkedleaseNo'] = this.enableLinkedUnitLeaseNo;
        const dbValue = response.DisableStripeAchOnfile;
        this.tenantAutoPayDetails['DisableStripeAchOnfile'] = this.disableStripeAchOnfile ?? dbValue;
        this.customerDataService.customerAutoPayDetails = JSON.parse(JSON.stringify(this.tenantAutoPayDetails));
        this.emitAutopayData.emit(this.tenantAutoPayDetails);
        if (this.isUnitChanged) {
          this.patchAutopayData(this.tenantAutoPayDetails);
      }
        this.isUnitChanged = false;
      }
    });
  }

  patchAutopayData(details : any) {
    this.facilityCode = details.FacilityId;
    this.leaseNo = details.LeaseNo;
    this.checkautoPay = details.Autopay || details.ACHPayment || details.DirectDebit ? true : false;
    this.printAutopay = details.PrintPaymentReceipt;
    this.email = details.EmailPaymentReceipt;
    if(this.paymentGateWay == EPaymentGateway.TdBank){
      this.SeriesId = details.SeriesId;
    }else if(this.paymentGateWay== EPaymentGateway.Stripe){
      this.customerId = details.CustomerId;
    }
    if (details.ACHPayment || details.ACHPaymentAccountId) {
      this.autoCCDays = details.ACHProcessingDay;
      this.modeSelect = (details.DirectDebit || details.IsStripeEFT) ? 'EFT' : (details.ACHPayment || details.ACHPaymentAccountId) ? 'ACH' : '0';
      this.ACHForm = (details.ACHPayment || details.ACHPaymentAccountId) || details.IsStripeEFT == true ? true : false;
      this.ACHRoutingNo = details.ACHRoutingNo;
      this.ACHaccountclass = details.ACHAccountClass;
      this.ACHaccountno = details.ACHAccountNo;
      this.ACHaccounttype = details.ACHAccountType;
      this.emitAliaseKey = details.ACHPaymentAccountId;
      this.mandateId = details.MandateId;
    } else if (details.CreditCardType || (details.CreditCardNumber && details.PaymentAccountId)) {
      this.autoCCDays = details.AutoCcProcessingDay;
      this.nameOnCard = details.NameonCard;
      this.cardNumber = details.CreditCardNumber;
      this.expMonth = details.CreditCardExpiryMonth;
      this.expYear = details.CreditCardExpiryYear;
      this.cTypeId = details.CreditCardType;
      this.modeSelect = details.Autopay || details.PaymentAccountId ? 'CardWebsite' : '0';
      this.CardWebsiteForm = details.Autopay == true ? true : false;
      this.zipCode = details.CreditCardBillingZip;
      this.Address = details.CreditCardBillingAddress;
      this.emitAliaseKey = details.PaymentAccountId;
      this.CardWebsiteForm =  this.modeSelect == 'CardWebsite' ? true:false;
    }
    else if (details.DirectDebit || (details.AccountHolder && details.TransitNo)
    ) {
      this.autoCCDays = details.DirectDebitProcessingDay;
      this.modeSelect = details.DirectDebit == true ? 'EFT' : '0';
      this.EFTForm = details.DirectDebit == true ? true : false;
      this.bankcode = details.BankCode;
      this.Accountname = details.AccountHolder;
      this.transitNo = details.TransitNo;
      this.Accountnumber = details.BankAccountNo;
    }
  }

  disableAutoPayCheckbox() {
    if (this.autopayInfoForUnit?.Mode == 'EFT' && this.checkautoPay) {
      return true;
    } else {
      this.disableFieldsForHistory();
    }
  }

  resetAutopayDetails() {
    this.checkautoPay = false;
    this.autoCCDays = 0;
    this.email = false;
    this.printAutopay = false;
    if (this.modeSelect == 'ACH') {
      this.ACHRoutingNo = '';
      this.ACHaccountclass = '';
      this.ACHaccountno = '';
      this.ACHaccounttype = '';
      this.emitAliaseKey = '';
    } else if (this.modeSelect == 'CardWebsite') {
      this.nameOnCard = '';
      this.cardNumber = '';
      this.expMonth = null;
      this.expYear = null;
      this.cTypeId = null;
      this.zipCode = '';
      this.Address = '';
      this.emitAliaseKey = '';
    } else if (this.modeSelect == 'EFT') {
      this.Eftcustomerform.form.reset();
      this.EFTForm = false;
      this.bankcode = '';
      this.Accountname = '';
      this.transitNo = '';
      this.Accountnumber = '';
    }
  }

  onDeleteAutoPayClick(template: TemplateRef<any>) {
    this.modalDeleteAutopay = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
  }

  setInitialAutopayData() {
    let mainFormObj = {
      checkautoPay: this.checkautoPay,
      autoCCDays: this.autoCCDays ? this.autoCCDays.toString() : '0',
      email: this.email,
      printAutopay: this.printAutopay,
      modeSelect: this.modeSelect ? this.modeSelect.toString() : '0'
    }
    this.initialData = mainFormObj;

    let eftFormObj = {
      Accountname: this.Accountname,
      bankcode: this.bankcode,
      transitNo: this.transitNo,
      Accountnumber: this.Accountnumber
    }
    this.initialEftData = eftFormObj;

    let ccAndAchObj = {
      emitAliaseKey: this.emitAliaseKey
    }
    this.initialCcAndAchData = ccAndAchObj;
  }

  disableAutopaySave() {
    if (this.isPayFieldsEnrollmentPending || this.showPayFieldsCardOnFileForm) return true;
    let currentData = {
      checkautoPay: this.checkautoPay,
      autoCCDays: this.autoCCDays ? this.autoCCDays.toString() : '0',
      email: this.email,
      printAutopay: this.printAutopay,
      modeSelect: this.modeSelect ? this.modeSelect.toString() : '0'
    }
    let currentEFTData = {
      Accountname: this.Accountname,
      bankcode: this.bankcode,
      transitNo: this.transitNo,
      Accountnumber: this.Accountnumber
    };
    if (this.disablesavebutton) {
      return true;
    }
    if (this.disableFieldsForHistory()) {
      return true;
    } else if (this.modeSelect == '0') {
      return true;
    } else {
      if (this.commonMethod.areDataEqual(currentData, this.initialData)) {
        return this.isAutopayModeDataUnchanged(currentEFTData, true);
      } else {
        return this.isAutopayModeDataUnchanged(currentEFTData, false);
      }
    }
  }

  isAutopayModeDataUnchanged(currentEFTData: any, isMainFormUnchanged): boolean {
    if (['ACH', 'CardTerminal', 'CardWebsite'].includes(this.modeSelect)) {
      if (isMainFormUnchanged && !this.statusAutopay.isProcessed) {
        return true;
      } else if (this.statusAutopay.isFailed) {
        return true;
      }
    }
    if (this.modeSelect === 'EFT') {
      if (isMainFormUnchanged && this.commonMethod.areDataEqual(currentEFTData, this.initialEftData)) {
        return false;
      } else if (this.paymentGateWay === EPaymentGateway.Stripe) {
        return false;
      } else if (this.Eftcustomerform.form.invalid || !this.checkautoPay) {
        return true;
      }
    }
    return false;
  }

  setDataOnAutopayFormOpen() {
    this.autoAchForm.patchValue({ ACHAccounttype: EACHAccountType.Checking });
    switch (this.modeSelect) {
      case 'EFT':
        this.EFTForm = true;
        break;
      case 'CardTerminal':
        this.CardTerminalForm = true;
        break;
      case 'CardWebsite':
        this.CardWebsiteForm = true;
        break;
      case 'ACH':
        this.ACHForm = true;
        break;
    }
  }

  openModal() {
    this.modalWrapper.openDirective(this.autoPayModalRef);
  }

  closeModal() {
    this.autoPayModalRef.hide();
  }

  cancelAndCloseModal() {
    if (this.isPayFieldsEnrollmentPending) return;
    if (this.showPayFieldsCardOnFileForm) this.onPayFieldsCardOnFileCancel();
    this.resetautopay();
    this.closeModal();
  }

  saveAndCloseModal() {
    if (this.isPayFieldsEnrollmentPending || this.showPayFieldsCardOnFileForm) return;
    this.onClickSave();
    this.closeModal();
  }

  setAutopayStatusObj(value) {
    let obj = {
      isProcessed: value == 'Success' ? true : false,
      isFailed: value == 'Failed' ? true : false
    }
    this.statusAutopay = obj;
  }

  onClickLinkeAutopay(eve) {
    this.linkedAutopayModalRef.hide();
    if (eve) {
      this.enableLinkedUnitLeaseNo = this.autopayLinledUnitList.map(ele => ele.LeaseNumber);
    } else {
      this.enableLinkedUnitLeaseNo = [];
    }
    this.emitResponse(false);
  }

  async setUpStripeTerminalAutopay(uniqueOrderId) {
    const isQuickProspect = this.quickProspectTenantInfo?.IsQuickProspect;
    // Guard: prevent double-invocation while a connection attempt is already in progress.
    if (this.initiatedStripEMVPayment) return;
    this.isProcessAutoPayComplete.isProcessed = false;
    this.isProcessAutoPayComplete.OrderId = uniqueOrderId;
    this.stripeLoader.isStripeterminal = this.initiatedStripEMVPayment = true;
    this.loaderIconTD = Promise.resolve(true);
    this.isStripeResetTerminal = false;
    try {
      await this.signalRService.startConnection(this.baseUrl);
    } catch (err) {
      console.error('SignalR connection failed before terminal autopay:', err);
      this.stripeLoader.isStripeterminal = this.initiatedStripEMVPayment = false;
      this.loaderIconTD = Promise.resolve(false);
      return;
    }
    const obj = {
      OrderId: uniqueOrderId,
      DeviceId: this.selectStripeReaderId,
      TenantId: this.TenantId ? this.TenantId : 0,
      Name: isQuickProspect ? this.quickProspectTenantInfo.Name : `${this.customerInfo.FirstName}${this.customerInfo.MiddleName ? ' ' + this.customerInfo.MiddleName : ''} ${this.customerInfo.LastName}`.trim(),
      Email: isQuickProspect ? this.quickProspectTenantInfo.Email : this.customerInfo.Email,
      Phone: isQuickProspect ? this.quickProspectTenantInfo.Phone : this.customerInfo.CellPhoneNumber,
      FacilityId: this.Currentstore,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      IsQuickProspectPayment: isQuickProspect,
      Customer: this.customerId,
      SignalRConnectionId: this.signalRService.getConnectionId()
    };
    this.paymentService.SetupTerminalAutopay(obj).subscribe((stripeRes: any) => {
      if (stripeRes) {
        this.setupTerminalAutoPayRes = stripeRes
        if (!stripeRes.Success) {
          this.autopayFailed = true;
          this.isStripeResetTerminal = stripeRes.Reason == 'Another Transaction is in Progress';
          this.isProcessAutoPayComplete.isProcessed = true;
          this.autopayFailReason = stripeRes.Reason ?? "Failed to Create SetUpIntent!";
          this.stripeLoader.isStripeterminal = this.initiatedStripEMVPayment = false;
          this.loaderIconTD = Promise.resolve(false);
          this.signalRService.stopConnection();
          this.saveStripeCCTransaction(stripeRes, this.initialCCTOrderId, EPaymentModes.CreditCard);
        } else {
          this.signalRService.addStripeResponseListener("ReceiveAutopayUpdate");
          this.stripeResponseSubscription = this.signalRService.stripeResponse$.subscribe((response: any) => {
            this.signalRService.stopConnection();
            this.stripeResponseSubscription.unsubscribe();
            this.stripeResponseSubscription = null;
            this.stripeLoader.isStripeterminal = this.initiatedStripEMVPayment = false;
            this.isProcessAutoPayComplete.isProcessed = true;
            let resultResponse = JSON.parse(response);
            if (resultResponse.Success) {
              this.setAutopayStatusObj('Success');
              this.bankcode = "";
              this.Accountname = "";
              this.emitAliaseKey = resultResponse.PaymentMethodId;
              this.cardNumber = `XXXXXXXXXXX${resultResponse.CreditCardNumber}`,
                this.expYear = parseInt(resultResponse.ExpiryYear, 10);
              this.expMonth = this.getExpiryMonthValue(parseInt(resultResponse.ExpiryMonth, 10));
              this.nameOnCard = resultResponse.CreditHolderName;
              this.cTypeId = this.paymentService.openEdgeCardType(resultResponse.CardBrand);
              this.process = true;
              this.customerId = resultResponse?.CustomerId ?? "";
            } else {
              this.setAutopayStatusObj('Failed');
              this.initiatedVoidCC = false;
              this.autopayFailed = true;
              this.autopayFailReason = resultResponse.Reason;
            }
            this.saveStripeCCTransaction(resultResponse, this.initialCCTOrderId, EPaymentModes.CreditCard);
            this.loaderIconTD = Promise.resolve(false);
          }, err => {
            this.setAutopayStatusObj('Failed');
            this.autopayFailed = true;
            this.stripeLoader.isStripeterminal = this.isTDEmv.isTransactionWaitTime = this.initiatedStripEMVPayment = false;
            this.isProcessAutoPayComplete.isProcessed = true;
            this.loaderIconTD = Promise.resolve(false);
            this.saveStripeCCTransaction(stripeRes, this.initialCCTOrderId, EPaymentModes.CreditCard);
          });
        }
      }
    }, err => {
      this.signalRService.stopConnection();
      this.isProcessAutoPayComplete.isProcessed = this.autopayFailed = true;
      this.autopayFailReason = err?.statusText ?? 'Declined!';
      this.stripeLoader.isStripeterminal = this.isTDEmv.isTransactionWaitTime = this.initiatedStripEMVPayment = false;
      this.loaderIconTD = Promise.resolve(false);
      const obj = {
        ResponseCode: err?.status ?? '',
        Reason: this.autopayFailReason
      };
      this.saveStripeCCTransaction(obj, this.initialCCTOrderId, EPaymentModes.CreditCard);
    });
    setTimeout(() => {
      if (this.isProcessAutoPayComplete.OrderId == uniqueOrderId && !this.isProcessAutoPayComplete.isProcessed) {
        if (this.stripeResponseSubscription != null) {
          this.stripeResponseSubscription.unsubscribe();
          this.stripeResponseSubscription = null;
        }
        this.getSetUpIntentStatus(true);
      }
    }, 10000 * 6 * this.paymentMaxWaitTime);
  }

  saveStripeACHTransaction(stripeResponse, orderId, paymentMode) {
    const ACHModel = {
      LeaseNo: this.leaseNo,
      FacilityId: this.Currentstore,
      Amount: 0,
      OrderId: orderId,
      Autopay: false,
      paymentModeId: paymentMode,
      AutoCcProcessingDay: 0,
      Reason: stripeResponse?.RESPONSEDESCRIPTION ?? '',
      AchAccountNumber: stripeResponse?.ACCOUNT ?? '',
      AchRoutingNumber: stripeResponse?.ROUTINGNUMBER ?? '',
      PaymentAccountId: stripeResponse?.PaymentMethodId ?? '',
      PaymentIntentId: this.stripeSetupIntent,
      AchAuthorizationCode: "",
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      TransactionTypeId: EPaymentTransactionType.Processed,
      ActIntAchaccountType: EACHAccountType.Checking,
      AchAccountClass: 276,
      ResponseCode: "00",
      TenantId: this.TenantId ? this.TenantId : null,
      GatewayDetails: this.paymentService.requestGatewaydetails(this.credentials, this.paymentGateWay, '')
    };
    this.paymentService.saveACHTransaction(Object.assign(ACHModel)).subscribe((res: any) => { 
      this.disableStripeAchOnfile = stripeResponse?.RESPONSEDESCRIPTION == 'requires_action' || stripeResponse?.RESPONSEDESCRIPTION == "verify_with_microdeposits"
      this.tenantAutoPayDetails['DisableStripeAchOnfile'] = this.disableStripeAchOnfile;
    });
  }

  saveStripeCCTransaction(stripeResponse, orderId, paymentMode) {
    const CCModel = {
      Amount: 0,
      Autopay: false,
      paymentModeId: paymentMode,
      AutoCcProcessingDay: 0,
      CreditCardNumber: stripeResponse.CreditCardNumber ? `XXXXXXXXXXX${stripeResponse.CreditCardNumber}` : '0',
      CreditCardType: stripeResponse.CardBrand ? this.paymentService.openEdgeCardType(stripeResponse.CardBrand) : ECreditCards.Visa,
      NameonCard: stripeResponse.CreditHolderName ? stripeResponse.CreditHolderName : "",
      CreditCardExpiryMonth: stripeResponse.ExpiryMonth ? this.getExpiryMonthValue(parseInt(stripeResponse.ExpiryMonth, 10)) : 275,
      CreditCardExpiryYear: stripeResponse.ExpiryYear ? parseInt(stripeResponse.ExpiryYear, 10) : 2099,
      CreditCardBillingAddress: stripeResponse?.CreditCardBillingAddress ? stripeResponse.CreditCardBillingAddress.trim().slice(0, 50) : '',
      CreditCardBillingZip: stripeResponse?.CreditCardBillingZip ?? "",
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: stripeResponse.PaymentMethodId ? stripeResponse.PaymentMethodId : "",
      ResponseCode: stripeResponse.ResponseCode ? stripeResponse.ResponseCode : "",
      Reason: stripeResponse.Reason ? stripeResponse.Reason : "",
      PaymentAccountid: stripeResponse.PaymentMethodId ? stripeResponse.PaymentMethodId : "",
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      Key: stripeResponse.SetupIntentId,
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      OrderId: orderId,
      FacilityId: this.Currentstore,
      TransactionDateTime: new Date(),
      TransactionTypeId: stripeResponse.Success ? EPaymentTransactionType.Processed : EPaymentTransactionType.Declined,
      TerminalDeviceId: null,
      TenantId: this.TenantId ? this.TenantId : null,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      GatewayDetails: this.paymentService.requestGatewaydetails(this.credentials, this.paymentGateWay, paymentMode == EPaymentModes.CreditCard ? this.selectStripeReaderId : '')
    };
    this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
  }

  callStripeHostedPage() {
    this.loaderIconTD = Promise.resolve(false);
    this.stripeModalRef = this.modalService.show(this.showStripePage, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
  }

  closeStripeModal(eve) {
    this.stripeModalRef.hide();
    this.IsmodelShow = false;
    this.modeSelect = 0;
    this.setAutopayStatusObj('Reset');
    if (this.selectedPaymentMode == EPaymentModes.HostedPage) {
      const stripFailedResponse = {
        Reason: 'Autopay Cancelled By User!',
        Key: this.stripeSetupIntent
      };
      const obj = {
        amountToPay: 0,
        paymentMode: this.selectedPaymentMode,
        paymentTrnsId: EPaymentTransactionTypes.ProcessCreditCard,
        orderId: this.initialCCTOrderId,
        requestgatewaydetails: this.paymentService.requestGatewaydetails(this.credentials, this.paymentGateWay, '')
      }
      const processAutopay = {
        facId: this.Currentstore,
        TenantId: this.TenantId,
        LeaseNo: this.leaseNo
      };
      const CCModel = this.paymentService.saveCCTFailModelStripe(stripFailedResponse, processAutopay, obj);
      this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
    } else {
      const obj = {
        RESPONSEDESCRIPTION: 'Autopay Cancelled By User!'
      }
      this.saveStripeACHTransaction(obj, this.initialACHOrderId, this.selectedPaymentMode);
    }
  }

  getConfirmationTokenData(confirmedSetupIntent) {
    this.loaderIconTD = Promise.resolve(true);
    this.paymentService.GetCardDetailsByPaymentMethodId(this.Currentstore, confirmedSetupIntent.payment_method).subscribe((response: any) => {
      if (this.stripeModalRef) {
        this.stripeModalRef.hide();
      }
      this.loaderIconTD = Promise.resolve(false);
      if (response) {
        if ([EPaymentModes.HostedPage, EPaymentModes.CreditCard].includes(this.selectedPaymentMode)) {
          this.setAutopayStatusObj('Success');
          this.emitAliaseKey = confirmedSetupIntent.payment_method;
          this.cardNumber = `XXXXXXXXXXX${response.CreditCardNumber}`,
            this.expYear = parseInt(response.ExpiryYear, 10);
          this.expMonth = this.getExpiryMonthValue(parseInt(response.ExpiryMonth, 10));
          this.nameOnCard = response.BillingDetails?.Name;
          this.zipCode = response.BillingDetails?.Address?.PostalCode;
          this.Address = response.BillingDetails?.Address?.Line1;
          this.cTypeId = this.paymentService.openEdgeCardType(response.CardBrand);
          this.process = true;
          this.customerId = response.CustomerId;
          let stripeRes = this.getStripeRes(response, confirmedSetupIntent.payment_method, true);
          this.saveStripeCCTransaction(stripeRes, this.initialCCTOrderId, EPaymentModes.HostedPage);
        } else if ([EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(this.selectedPaymentMode)) {
          this.mandateId = response.MandateId;
          this.setAutopayStatusObj('Success');
          this.IsmodelShow = false;
          this.emitAliaseKey = confirmedSetupIntent.payment_method;
          this.process = true;
          let stripeRes = this.getStripeACHRes(response, confirmedSetupIntent.payment_method, true);
          this.autopayFailed = false;
          this.ACHRoutingNo = response.RoutingNumber;
          this.ACHaccountno = response.AccountNumber;
          this.Accountname = response?.AccountName ?? "";
          this.ACHaccountclass = 276;
          this.ACHaccounttype = 278;
          this.customerId = response.CustomerId;
          this.saveStripeACHTransaction(stripeRes, this.initialACHOrderId, this.selectedPaymentMode);
        }
      } else {
        this.toastr.warning('Please Try again!', 'Alert', this.toasterConfig);
        this.autopayFailed = true;
        this.setAutopayStatusObj('Failed');
        let stripeRes = this.getStripeRes(response, confirmedSetupIntent.payment_method, false);
        this.saveStripeCCTransaction(stripeRes, this.initialCCTOrderId, EPaymentModes.HostedPage);
      }
    }, err => {
      if (this.stripeModalRef) {
        this.stripeModalRef.hide();
      }
      let stripeRes = this.getStripeRes(null, confirmedSetupIntent.payment_method, false);
      this.saveStripeCCTransaction(stripeRes, this.initialCCTOrderId, EPaymentModes.HostedPage);
      this.setAutopayStatusObj('Reset');
      this.toastr.warning('Please Try again!', 'Alert', this.toasterConfig);
      this.autopayFailed = true;
      this.loaderIconTD = Promise.resolve(false);
    });
  }

  getStripeRes(stripeResponse, PaymentMethodId, isSuccess) {
    let obj = {
      CreditCardNumber: stripeResponse.CreditCardNumber ? stripeResponse.CreditCardNumber : '0',
      CardBrand: stripeResponse?.CardBrand ?? 'visa',
      CreditHolderName: stripeResponse.BillingDetails?.Name ? stripeResponse.BillingDetails?.Name : "",
      ExpiryMonth: stripeResponse.ExpiryMonth ? this.getExpiryMonthValue(parseInt(stripeResponse.ExpiryMonth, 10)) : 275,
      ExpiryYear: stripeResponse.ExpiryYear ? parseInt(stripeResponse.ExpiryYear, 10) : 2099,
      CreditCardBillingAddress: stripeResponse.BillingDetails?.Address?.Line1 ? stripeResponse.BillingDetails?.Address?.Line1 : " ",
      CreditCardBillingZip: stripeResponse.BillingDetails?.Address?.PostalCode ? stripeResponse.BillingDetails?.Address?.PostalCode : " ",
      PaymentMethodId: PaymentMethodId ? PaymentMethodId : "",
      ResponseCode: "",
      Reason: isSuccess ? 'Success' : 'Failed',
      SetupIntentId: this.stripeSetupIntent,
      Success: isSuccess ? true : false,
    }
    return obj;
  }

  handleLoaderStatus(status: boolean) {
    this.isLoaderActive = status;
  }

  getStripeACHRes(stripeResponse, PaymentMethodId, isSuccess) {
    {
      let ACHObj = {
        RESPONSEDESCRIPTION: stripeResponse.Status,
        ACCOUNT: stripeResponse.AccountNumber,
        ROUTINGNUMBER: stripeResponse.RoutingNumber,
        PaymentAccountId: stripeResponse.PaymentMethodId,
        Success: isSuccess ? true : false,
        PaymentIntentId: this.stripeSetupIntent,
        PaymentMethodId: PaymentMethodId ? PaymentMethodId : "",
      }
      return ACHObj;
    }
  }

  emitPaymentTerminalStatus(eve) {
    if (eve == 'Status') {
      this.getSetUpIntentStatus(false);
    } else {
      this.cancelTerminalAction(false);
    }
  }

  getSetUpIntentStatus(isTimeout) {
    this.paymentService.getCardDetailsBySetupIntentId(this.setupTerminalAutoPayRes.PaymentIntentId, this.Currentstore).subscribe(async (resultResponse: any) => {
      if (resultResponse.Success) {
        this.isProcessAutoPayComplete.isProcessed = true;
        this.setAutopayStatusObj('Success');
        this.bankcode = "";
        this.Accountname = "";
        this.emitAliaseKey = resultResponse.PaymentMethodId;
        this.cardNumber = `XXXXXXXXXXX${resultResponse.CreditCardNumber}`,
          this.expYear = parseInt(resultResponse.ExpiryYear, 10);
        this.expMonth = this.getExpiryMonthValue(parseInt(resultResponse.ExpiryMonth, 10));
        this.nameOnCard = resultResponse.CreditHolderName;
        this.cTypeId = this.paymentService.openEdgeCardType(resultResponse.CardBrand);
        this.process = true;
        this.customerId = resultResponse?.CustomerId ?? "";
        this.saveStripeCCTransaction(resultResponse, this.initialCCTOrderId, EPaymentModes.CreditCard);
        this.stripeLoader.isStripeterminal = this.initiatedStripEMVPayment = this.isTDEmv.isTransactionWaitTime = false;
        this.loaderIconTD = Promise.resolve(false);
      } else if (!isTimeout) {
        this.toastr.info("Your transaction is in progress. Please wait...", "Info", this.toasterConfig);
      }
    });

    if (isTimeout) {
      this.cancelTerminalAction(true);
    }
  }

  cancelTerminalAction(isTimeout) {
    this.stripeLoader.isStripeterminal = this.initiatedStripEMVPayment = this.isTDEmv.isTransactionWaitTime = false;
    this.setupTerminalAutoPayRes.Reason = isTimeout ? 'Transaction Time Out!' : "Transaction Cancelled by User!";
    this.paymentService.CancelTerminalAction(this.selectStripeReaderId, this.Currentstore).subscribe((res: any) => {
      this.isProcessAutoPayComplete.isProcessed = true;
      this.autopayFailed = true;
      this.autopayFailReason = this.setupTerminalAutoPayRes.Reason;
      this.setAutopayStatusObj('Failed');
      this.loaderIconTD = Promise.resolve(false);
      this.saveStripeCCTransaction(this.setupTerminalAutoPayRes, this.initialCCTOrderId, EPaymentModes.CreditCard);
      if (!res) {
        this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
      }
    }, err => {
      this.isProcessAutoPayComplete.isProcessed = true;
      this.saveStripeCCTransaction(this.setupTerminalAutoPayRes, this.initialCCTOrderId, EPaymentModes.CreditCard);
      this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
    });
  }

  resetStripeTerminal() {
    this.paymentService.CancelTerminalAction(this.selectStripeReaderId, this.Currentstore).subscribe((res: any) => {
      if (!res) {
        this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
      } else {
        this.toastr.success('Terminal device Reset successfully', 'Success', this.toasterConfig);
      }
    }, err => {
      this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
    });
  }

  onSelectDevice() {
    this.modalRefSelectDevice.hide();
    this.loaderIconTD = Promise.resolve(true);
    this.setUpStripeTerminalAutopay(this.initialCCTUniqueId);
  }

  OnCardcancel() {
    this.selectStripeReaderId = '';
    this.modalRefSelectDevice.hide();
  }

  saveOpenEdgeCCTransaction(gatewayResponse, paymentMode, responseDiscription, transactionType, completed?: (success: boolean) => void, card: any = this) {
    let gatewayDetails = this.paymentService.requestGatewaydetails(this.credentials, this.paymentGateWay, paymentMode);
    if (gatewayResponse?.PayFieldPayment) {
      gatewayDetails = JSON.stringify({
        PayFieldReferenceVersion: 2,
        XWebId: this.credentials?.PAYFIELDSXWEBID ?? '',
        XWebTerminalId: this.credentials?.PAYFIELDSXWEBTERMINALID ?? '',
        XWebAuthKey: this.credentials?.PAYFIELDSXWEBAUTHKEY ?? '',
        PayField: true,
        Environment: this.getPayFieldsEnvironment(),
        Region: ([this.credentials?.PayFieldMerchantCountry, this.credentials?.Region, this.credentials?.PayFieldRegion]
          .find(value => this.hasCredentialValue(value)) ?? '').toString(),
        ApiSecret: [this.credentials?.ApiSecret, this.credentials?.PayFieldApiSecret, this.credentials?.PAYFIELDSTRANSACTIONSAPISECRET]
          .find(value => this.hasCredentialValue(value)) ?? ''
      });
    }
    const CCModel = {
      Amount: 0,
      Autopay: false,
      PaymentModeId: paymentMode,
      AutoCcProcessingDay: this.autopaydata?.autoCcDays ?? this.autoCCDays,
      CreditCardNumber: card.cardNumber ?? '',
      CreditCardType: card.cTypeId,
      NameonCard: card.nameOnCard && card.nameOnCard.length > 30 ? card.nameOnCard.substr(0, 30) : card.nameOnCard ?? '',
      CreditCardExpiryMonth: card.expMonth ? this.getExpiryMonthValue(parseInt(card.expMonth, 10)) : 275,
      CreditCardExpiryYear: card.expYear ? parseInt(card.expYear, 10) : 2099,
      CreditCardBillingAddress: gatewayResponse?.ADDRESS1 && gatewayResponse.ADDRESS1.length > 50 ?
        gatewayResponse.ADDRESS1.substr(0, 50) : gatewayResponse?.ADDRESS1 ?? '',
      CreditCardBillingZip: gatewayResponse?.BILLINGPOSTALCODE && gatewayResponse.BILLINGPOSTALCODE.length > 15 ?
        gatewayResponse.BILLINGPOSTALCODE.substr(0, 15) : gatewayResponse?.BILLINGPOSTALCODE ?? '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: gatewayResponse?.TRANSACTIONID ?? '',
      ResponseCode: paymentMode == EPaymentModes.CreditCard ? gatewayResponse?.HOSTRESPONSECODE ?? '' : (gatewayResponse?.RESPONSECODE ?? ''),
      Reason: responseDiscription,
      Key: '',
      PaymentAccountid: card.emitAliaseKey ? card.emitAliaseKey : null,
      CcInfoPurged: false,
      DebitCardPayment: gatewayResponse?.CARDTYPE == 'Credit' ? false : true,
      OfflinePayment: 0,
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      FacilityId: this.Currentstore,
      TransactionTypeId: transactionType,
      OrderId: this.initialCCTOrderId,
      CCBatchNumber: gatewayResponse?.BATCHNO ?? '',
      TenantId: this.TenantId ? this.TenantId : null,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      TerminalDeviceId: null,
      EmvReceiptText: gatewayResponse?.RECEIPTTEXT ?? null,
      GatewayDetails: gatewayDetails,
      UniqueTransId: card.OrderId
    };
    this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => {
      completed?.(!!res && res.Success !== false && (res.Success === true || res.Id > 0));
    }, () => completed?.(false));
  }

  saveAchTransactions(achResponse, transactionType, reason, paymentMode) {
    this.loaderIcon = Promise.resolve(false);
    const achModel = {
      Amount: 0,
      Autopay: false,
      paymentModeId: paymentMode,
      AutoACHProcessingDay: 0,
      AchAccountNumber: achResponse?.ACCOUNT ?? 0,
      AchRoutingNumber: achResponse?.ROUTINGNUMBER ?? 0,
      AccountClass: this.ACHaccountclass ?? 277,
      AchAccountType: this.ACHaccounttype ?? EACHAccountType.Checking,
      SwipeTransaction: false,
      AutoAchPayment: false,
      AuthorizationCode: 0,
      ResponseCode: achResponse?.RESPONSECODE ?? "0",
      Reason: reason ? reason : (achResponse?.RESPONSEDESCRIPTION ?? "Declined!"),
      CcInfoPurged: false,
      OfflinePayment: false,
      ACHInfoPurged: false,
      PaymentAccountId: this.emitAliaseKey,
      PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
      OrderId: this.initialACHOrderId,
      FacilityId: this.Currentstore,
      TransactionDateTime: new Date(),
      TransactionTypeId: transactionType,
      TenantId: this.TenantId ? this.TenantId : null,
      LeaseNo: this.leaseNo ? this.leaseNo : null,
      ReceiptText: achResponse?.RECEIPTTEXT ?? null,
      GatewayDetails: this.paymentService.requestGatewaydetails(this.credentials, this.paymentGateWay, '')
    };
    this.paymentService.saveACHTransaction(Object.assign(achModel)).subscribe((res) => { });
  }
}
